
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $ff68197639d628de$var$n, $ff68197639d628de$export$41c562ebe57d11e2, $ff68197639d628de$var$u, $ff68197639d628de$export$a8257692ac88316c, $ff68197639d628de$var$i, $ff68197639d628de$var$o, $ff68197639d628de$var$r, $ff68197639d628de$var$f, $ff68197639d628de$var$e, $ff68197639d628de$var$c, $ff68197639d628de$var$s, $ff68197639d628de$var$a, $ff68197639d628de$var$h = {}, $ff68197639d628de$var$v = [], $ff68197639d628de$var$p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $ff68197639d628de$var$y = Array.isArray;
function $ff68197639d628de$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $ff68197639d628de$var$w(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $ff68197639d628de$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $ff68197639d628de$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $ff68197639d628de$var$g(l, f, i, o, null);
}
function $ff68197639d628de$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$ff68197639d628de$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $ff68197639d628de$export$41c562ebe57d11e2.vnode && $ff68197639d628de$export$41c562ebe57d11e2.vnode(f), f;
}
function $ff68197639d628de$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $ff68197639d628de$export$ffb0004e005737fa(n) {
    return n.children;
}
function $ff68197639d628de$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $ff68197639d628de$var$x(n, l) {
    if (null == l) return n.__ ? $ff68197639d628de$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $ff68197639d628de$var$x(n) : null;
}
function $ff68197639d628de$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $ff68197639d628de$var$C(n);
    }
}
function $ff68197639d628de$var$S(n) {
    (!n.__d && (n.__d = !0) && $ff68197639d628de$var$i.push(n) && !$ff68197639d628de$var$M.__r++ || $ff68197639d628de$var$o !== $ff68197639d628de$export$41c562ebe57d11e2.debounceRendering) && (($ff68197639d628de$var$o = $ff68197639d628de$export$41c562ebe57d11e2.debounceRendering) || $ff68197639d628de$var$r)($ff68197639d628de$var$M);
}
function $ff68197639d628de$var$M() {
    var n, u, t, o, r, e, c, s;
    for($ff68197639d628de$var$i.sort($ff68197639d628de$var$f); n = $ff68197639d628de$var$i.shift();)n.__d && (u = $ff68197639d628de$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $ff68197639d628de$var$d({}, r)).__v = r.__v + 1, $ff68197639d628de$export$41c562ebe57d11e2.vnode && $ff68197639d628de$export$41c562ebe57d11e2.vnode(o), $ff68197639d628de$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $ff68197639d628de$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $ff68197639d628de$var$j(c, o, s), o.__e != e && $ff68197639d628de$var$C(o)), $ff68197639d628de$var$i.length > u && $ff68197639d628de$var$i.sort($ff68197639d628de$var$f));
    $ff68197639d628de$var$M.__r = 0;
}
function $ff68197639d628de$var$P(n, l, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, w, _ = t && t.__k || $ff68197639d628de$var$v, g = l.length;
    for(u.__d = e, $ff68197639d628de$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && (p = -1 === y.__i ? $ff68197639d628de$var$h : _[y.__i] || $ff68197639d628de$var$h, y.__i = a, $ff68197639d628de$var$O(n, y, p, i, o, r, f, e, c, s), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $ff68197639d628de$var$E(p.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || p.__k === y.__k ? e = $ff68197639d628de$var$I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $ff68197639d628de$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = l[t]) && "boolean" != typeof i && "function" != typeof i ? (r = t + a, (i = n.__k[t] = "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $ff68197639d628de$var$g(null, i, null, null, null) : $ff68197639d628de$var$y(i) ? $ff68197639d628de$var$g($ff68197639d628de$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $ff68197639d628de$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i).__ = n, i.__b = n.__b + 1, o = null, -1 !== (f = i.__i = $ff68197639d628de$var$L(i, u, r, s)) && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a-- : f == r + 1 ? a++ : (f > r ? a-- : a++, i.__u |= 65536))) : i = n.__k[t] = null;
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $ff68197639d628de$var$x(o)), $ff68197639d628de$var$N(o, o));
}
function $ff68197639d628de$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $ff68197639d628de$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $ff68197639d628de$var$x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $ff68197639d628de$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($ff68197639d628de$var$y(n) ? n.some(function(n) {
        $ff68197639d628de$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $ff68197639d628de$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (("function" != typeof o || o === $ff68197639d628de$export$ffb0004e005737fa || i) && t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $ff68197639d628de$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $ff68197639d628de$var$p.test(l) ? u : u + "px";
}
function $ff68197639d628de$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $ff68197639d628de$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $ff68197639d628de$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $ff68197639d628de$var$e, n.addEventListener(l, o ? $ff68197639d628de$var$s : $ff68197639d628de$var$c, o)) : n.removeEventListener(l, o ? $ff68197639d628de$var$s : $ff68197639d628de$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $ff68197639d628de$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $ff68197639d628de$var$e++;
            else if (u.t < t.u) return;
            return $ff68197639d628de$export$41c562ebe57d11e2.event && (u = $ff68197639d628de$export$41c562ebe57d11e2.event(u)), "handleEvent" in t ? t.handleEvent(u) : t(u);
        }
    };
}
function $ff68197639d628de$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, v, p, w, _, g, m, x, C, S, M, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $ff68197639d628de$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], S = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, S) : (u.__c = h = new $ff68197639d628de$export$16fa2f45be04daa8(m, S), h.constructor = T, h.render = $ff68197639d628de$var$V), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = S, h.__n = i, v = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $ff68197639d628de$var$d({}, h.__s)), $ff68197639d628de$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), p = h.props, w = h.state, h.__v = u, v) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== p && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, S), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, S) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), M = 0; M < h._sb.length; M++)h.__h.push(h._sb[M]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, S), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(p, w, _);
            });
        }
        if (h.context = S, h.props = m, h.__P = n, h.__e = !1, $ = $ff68197639d628de$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $ff68197639d628de$var$d($ff68197639d628de$var$d({}, i), h.getChildContext())), x && !v && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(p, w)), $ff68197639d628de$var$P(n, $ff68197639d628de$var$y(L = null != a && a.type === $ff68197639d628de$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 128; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        $ff68197639d628de$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $ff68197639d628de$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $ff68197639d628de$export$41c562ebe57d11e2.diffed) && a(u);
}
function $ff68197639d628de$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$ff68197639d628de$var$E(t[i], t[++i], t[++i]);
    $ff68197639d628de$export$41c562ebe57d11e2.__c && $ff68197639d628de$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $ff68197639d628de$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $ff68197639d628de$var$z(u, t, i, o, r, f, e, c, s) {
    var a, v, p, d, _, g, m, b = i.props, k = t.props, C = t.type;
    if ("svg" === C ? r = "http://www.w3.org/2000/svg" : "math" === C ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), null != f) {
        for(a = 0; a < f.length; a++)if ((_ = f[a]) && "setAttribute" in _ == !!C && (C ? _.localName === C : 3 === _.nodeType)) {
            u = _, f[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null === C) return document.createTextNode(k);
        u = document.createElementNS(r, C, k.is && k), c && ($ff68197639d628de$export$41c562ebe57d11e2.__m && $ff68197639d628de$export$41c562ebe57d11e2.__m(t, f), c = !1), f = null;
    }
    if (null === C) b === k || c && u.data === k || (u.data = k);
    else {
        if (f = f && $ff68197639d628de$var$n.call(u.childNodes), b = i.props || $ff68197639d628de$var$h, !c && null != f) for(b = {}, a = 0; a < u.attributes.length; a++)b[(_ = u.attributes[a]).name] = _.value;
        for(a in b)if (_ = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) p = _;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $ff68197639d628de$var$A(u, a, null, _, r);
        }
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? m = _ : c && "function" != typeof _ || b[a] === _ || $ff68197639d628de$var$A(u, a, _, b[a], r);
        if (v) c || p && (v.__html === p.__html || v.__html === u.innerHTML) || (u.innerHTML = v.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $ff68197639d628de$var$P(u, $ff68197639d628de$var$y(d) ? d : [
            d
        ], t, i, o, "foreignObject" === C ? "http://www.w3.org/1999/xhtml" : r, f, e, f ? f[0] : i.__k && $ff68197639d628de$var$x(i, 0), c, s), null != f) for(a = f.length; a--;)$ff68197639d628de$var$w(f[a]);
        c || (a = "value", "progress" === C && null == g ? u.removeAttribute("value") : void 0 !== g && (g !== u[a] || "progress" === C && !g || "option" === C && g !== b[a]) && $ff68197639d628de$var$A(u, a, g, b[a], r), a = "checked", void 0 !== m && m !== u[a] && $ff68197639d628de$var$A(u, a, m, b[a], r));
    }
    return u;
}
function $ff68197639d628de$var$E(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $ff68197639d628de$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $ff68197639d628de$var$N(n, u, t) {
    var i, o;
    if ($ff68197639d628de$export$41c562ebe57d11e2.unmount && $ff68197639d628de$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $ff68197639d628de$var$E(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $ff68197639d628de$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $ff68197639d628de$var$N(i[o], u, t || "function" != typeof n.type);
    t || $ff68197639d628de$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $ff68197639d628de$var$V(n, l, u) {
    return this.constructor(n, u);
}
function $ff68197639d628de$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $ff68197639d628de$export$41c562ebe57d11e2.__ && $ff68197639d628de$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $ff68197639d628de$var$O(t, u = (!o && i || t).__k = $ff68197639d628de$export$c8a8987d4410bf2d($ff68197639d628de$export$ffb0004e005737fa, null, [
        u
    ]), r || $ff68197639d628de$var$h, $ff68197639d628de$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $ff68197639d628de$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $ff68197639d628de$var$j(f, u, e);
}
function $ff68197639d628de$export$fa8d919ba61d84db(n, l) {
    $ff68197639d628de$export$b3890eb0ae9dca99(n, l, $ff68197639d628de$export$fa8d919ba61d84db);
}
function $ff68197639d628de$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $ff68197639d628de$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $ff68197639d628de$var$n.call(arguments, 2) : t), $ff68197639d628de$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $ff68197639d628de$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $ff68197639d628de$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = new Set, (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.forEach(function(n) {
                    n.__e = !0, $ff68197639d628de$var$S(n);
                });
            }, this.sub = function(n) {
                u.add(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.delete(n), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$ff68197639d628de$var$n = $ff68197639d628de$var$v.slice, $ff68197639d628de$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $ff68197639d628de$var$u = 0, $ff68197639d628de$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $ff68197639d628de$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $ff68197639d628de$var$d({}, this.state), "function" == typeof n && (n = n($ff68197639d628de$var$d({}, u), this.props)), n && $ff68197639d628de$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $ff68197639d628de$var$S(this));
}, $ff68197639d628de$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $ff68197639d628de$var$S(this));
}, $ff68197639d628de$export$16fa2f45be04daa8.prototype.render = $ff68197639d628de$export$ffb0004e005737fa, $ff68197639d628de$var$i = [], $ff68197639d628de$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $ff68197639d628de$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $ff68197639d628de$var$M.__r = 0, $ff68197639d628de$var$e = 0, $ff68197639d628de$var$c = $ff68197639d628de$var$F(!1), $ff68197639d628de$var$s = $ff68197639d628de$var$F(!0), $ff68197639d628de$var$a = 0;



const $1a82a8f6307d60ea$export$1dbde90899e92635 = {
    appwrite: "Appwrite",
    astro: "Astro image service",
    "builder.io": "Builder.io",
    bunny: "Bunny.net",
    cloudflare: "Cloudflare",
    cloudflare_images: "Cloudflare Images",
    cloudimage: "Cloudimage",
    cloudinary: "Cloudinary",
    contentful: "Contentful",
    contentstack: "Contentstack",
    directus: "Directus",
    hygraph: "Hygraph",
    imageengine: "ImageEngine",
    imagekit: "ImageKit",
    imgix: "Imgix",
    ipx: "IPX",
    keycdn: "KeyCDN",
    "kontent.ai": "Kontent.ai",
    netlify: "Netlify Image CDN",
    nextjs: "Next.js image service",
    scene7: "Adobe Dynamic Media / Scene7",
    shopify: "Shopify",
    storyblok: "Storyblok",
    supabase: "Supabase",
    truocloud: "TruoCloud",
    uploadcare: "Uploadcare",
    vercel: "Vercel",
    wordpress: "WordPress",
    wsrv: "wsrv.nl"
};


var $1498aa0bcfcff63f$exports = {};
$1498aa0bcfcff63f$exports = JSON.parse("{\"images.ctfassets.net\":\"contentful\",\"cdn.builder.io\":\"builder.io\",\"images.prismic.io\":\"imgix\",\"img.truo.cloud\":\"truocloud\",\"www.datocms-assets.com\":\"imgix\",\"cdn.sanity.io\":\"imgix\",\"images.unsplash.com\":\"imgix\",\"cdn.shopify.com\":\"shopify\",\"s7d1.scene7.com\":\"scene7\",\"ip.keycdn.com\":\"keycdn\",\"assets.caisy.io\":\"bunny\",\"images.contentstack.io\":\"contentstack\",\"ucarecdn.com\":\"uploadcare\",\"imagedelivery.net\":\"cloudflare_images\",\"wsrv.nl\":\"wsrv\"}");


var $a6d61df9140eaa4a$exports = {};
$a6d61df9140eaa4a$exports = JSON.parse("{\"imgix.net\":\"imgix\",\"wp.com\":\"wordpress\",\"files.wordpress.com\":\"wordpress\",\"b-cdn.net\":\"bunny\",\"storyblok.com\":\"storyblok\",\"kc-usercontent.com\":\"kontent.ai\",\"cloudinary.com\":\"cloudinary\",\"kxcdn.com\":\"keycdn\",\"imgeng.in\":\"imageengine\",\"imagekit.io\":\"imagekit\",\"cloudimg.io\":\"cloudimage\",\"ucarecdn.com\":\"uploadcare\",\"supabase.co\":\"supabase\",\"graphassets.com\":\"hygraph\"}");


var $d1d0daaba06482b2$exports = {};
$d1d0daaba06482b2$exports = JSON.parse("{\"/cdn-cgi/image/\":\"cloudflare\",\"/cdn-cgi/imagedelivery/\":\"cloudflare_images\",\"/_next/image\":\"nextjs\",\"/_vercel/image\":\"vercel\",\"/is/image\":\"scene7\",\"/_ipx/\":\"ipx\",\"/_image\":\"astro\",\"/.netlify/images\":\"netlify\",\"/storage/v1/object/public/\":\"supabase\",\"/storage/v1/render/image/public/\":\"supabase\",\"/v1/storage/buckets/\":\"appwrite\"}");


function $7fc80789f446ee4c$export$633dc235a7124180(value) {
    if (!value) // deno-lint-ignore no-explicit-any
    return value;
    const num = Number(value);
    if (isNaN(num)) // deno-lint-ignore no-explicit-any
    return value;
    // deno-lint-ignore no-explicit-any
    return Math.round(num);
}
const $7fc80789f446ee4c$export$4ebdca5513a016fe = (url)=>{
    const { pathname: pathname, search: search } = url;
    return `${pathname}${search}`;
};
const $7fc80789f446ee4c$export$9a5ff27ac96579c6 = (url)=>{
    return url.hostname === "n" ? $7fc80789f446ee4c$export$4ebdca5513a016fe(url) : url.toString();
};
const $7fc80789f446ee4c$export$1758be3e5622c165 = (url, base)=>{
    return typeof url === "string" ? new URL(url, base ?? "http://n/") : url;
};
const $7fc80789f446ee4c$export$1e68cbf5a045c801 = (text)=>text === " " ? "+" : "%" + text.charCodeAt(0).toString(16).toUpperCase().padStart(2, "0");
const $7fc80789f446ee4c$export$79c5b1569e3be9e6 = (str)=>str?.startsWith("/") ? str.slice(1) : str;
const $7fc80789f446ee4c$export$d95b4586d238a081 = (str)=>str?.endsWith("/") ? str.slice(0, -1) : str;
const $7fc80789f446ee4c$export$5b4913142e03bca8 = (str)=>str?.startsWith("/") ? str : `/${str}`;
const $7fc80789f446ee4c$export$5899956e46ffac7a = (str)=>str?.endsWith("/") ? str : `${str}/`;
const $7fc80789f446ee4c$export$18fadbe56dfcb1a1 = (kvSeparator, paramSeparator)=>{
    const encodedValueJoiner = $7fc80789f446ee4c$export$1e68cbf5a045c801(kvSeparator);
    const encodedOperationJoiner = $7fc80789f446ee4c$export$1e68cbf5a045c801(paramSeparator);
    function escape(value) {
        return encodeURIComponent(value).replaceAll(kvSeparator, encodedValueJoiner).replaceAll(paramSeparator, encodedOperationJoiner);
    }
    function format(key, value) {
        return `${escape(key)}${kvSeparator}${escape(String(value))}`;
    }
    return (operations)=>{
        const ops = Array.isArray(operations) ? operations : Object.entries(operations);
        return ops.flatMap(([key, value])=>{
            if (value === undefined || value === null) return [];
            if (Array.isArray(value)) return value.map((v)=>format(key, v));
            return format(key, value);
        }).join(paramSeparator);
    };
};
const $7fc80789f446ee4c$export$88a1156fad04455f = (kvSeparator, paramSeparator)=>{
    if (kvSeparator === "=" && paramSeparator === "&") return $7fc80789f446ee4c$var$queryParser;
    return (url)=>{
        const urlString = url.toString();
        return Object.fromEntries(urlString.split(paramSeparator).map((pair)=>{
            const [key, value] = pair.split(kvSeparator);
            return [
                decodeURI(key),
                decodeURI(value)
            ];
        }));
    };
};
function $7fc80789f446ee4c$export$b2d1ff673228dec6(operations, maxWidth = 4000, maxHeight = 4000) {
    let { width: width, height: height } = operations;
    width = Number(width) || undefined;
    height = Number(height) || undefined;
    if (width && width > maxWidth) {
        if (height) height = Math.round(height * maxWidth / width);
        width = maxWidth;
    }
    if (height && height > maxHeight) {
        if (width) width = Math.round(width * maxHeight / height);
        height = maxHeight;
    }
    return {
        width: width,
        height: height
    };
}
function $7fc80789f446ee4c$export$3af18ed156c52f8d(url) {
    const parsedUrl = $7fc80789f446ee4c$export$1758be3e5622c165(url);
    const operations = Object.fromEntries(parsedUrl.searchParams.entries());
    for(const key in [
        "width",
        "height",
        "quality"
    ]){
        const value = operations[key];
        if (value) {
            const newVal = Number(value);
            if (!isNaN(newVal)) // deno-lint-ignore no-explicit-any
            operations[key] = newVal;
        }
    }
    parsedUrl.search = "";
    return {
        operations: operations,
        src: $7fc80789f446ee4c$export$9a5ff27ac96579c6(parsedUrl)
    };
}
function $7fc80789f446ee4c$export$a70232c872814f03({ keyMap: keyMap = {}, formatMap: formatMap = {}, defaults: defaults = {} }, operations) {
    if (operations.format && operations.format in formatMap) operations.format = formatMap[operations.format];
    if (operations.width) operations.width = $7fc80789f446ee4c$export$633dc235a7124180(operations.width);
    if (operations.height) operations.height = $7fc80789f446ee4c$export$633dc235a7124180(operations.height);
    for(const k in keyMap){
        if (!Object.prototype.hasOwnProperty.call(keyMap, k)) continue;
        const key = k;
        if (keyMap[key] === false) {
            delete operations[key];
            continue;
        }
        if (keyMap[key] && operations[key]) {
            operations[keyMap[key]] = operations[key];
            delete operations[key];
        }
    }
    for(const k in defaults){
        if (!Object.prototype.hasOwnProperty.call(defaults, k)) continue;
        const key = k;
        const value = defaults[key];
        if (!operations[key] && value !== undefined) {
            if (keyMap[key] === false) continue;
            const resolvedKey = keyMap[key] ?? key;
            if (resolvedKey in operations) continue;
            // deno-lint-ignore no-explicit-any
            operations[resolvedKey] = value;
        }
    }
    return operations;
}
const $7fc80789f446ee4c$var$invertMap = (// deno-lint-ignore no-explicit-any
map)=>Object.fromEntries(Object.entries(map).map(([k, v])=>[
            v,
            k
        ]));
function $7fc80789f446ee4c$export$8f574c745c7a98bb({ keyMap: keyMap = {}, formatMap: formatMap = {}, defaults: defaults = {} }, operations) {
    const invertedKeyMap = $7fc80789f446ee4c$var$invertMap(keyMap);
    const invertedFormatMap = $7fc80789f446ee4c$var$invertMap(formatMap);
    const ops = $7fc80789f446ee4c$export$a70232c872814f03({
        keyMap: invertedKeyMap,
        formatMap: invertedFormatMap,
        defaults: defaults
    }, operations);
    if (ops.width) ops.width = $7fc80789f446ee4c$export$633dc235a7124180(ops.width);
    if (ops.height) ops.height = $7fc80789f446ee4c$export$633dc235a7124180(ops.height);
    const q = Number(ops.quality);
    if (!isNaN(q)) ops.quality = q;
    return ops;
}
// Parses a query string
const $7fc80789f446ee4c$var$queryParser = (url)=>{
    const parsedUrl = $7fc80789f446ee4c$export$1758be3e5622c165(url);
    return Object.fromEntries(parsedUrl.searchParams.entries());
};
function $7fc80789f446ee4c$export$cf82431e47a456ee({ kvSeparator: kvSeparator = "=", paramSeparator: paramSeparator = "&", ...options } = {}) {
    const formatter = $7fc80789f446ee4c$export$18fadbe56dfcb1a1(kvSeparator, paramSeparator);
    return (operations)=>{
        const normalisedOperations = $7fc80789f446ee4c$export$a70232c872814f03(options, operations);
        return formatter(normalisedOperations);
    };
}
function $7fc80789f446ee4c$export$ac97658230dbc2cb({ kvSeparator: kvSeparator = "=", paramSeparator: paramSeparator = "&", defaults: _, ...options } = {}) {
    const parser = $7fc80789f446ee4c$export$88a1156fad04455f(kvSeparator, paramSeparator);
    return (url)=>{
        const operations = url ? parser(url) : {};
        return $7fc80789f446ee4c$export$8f574c745c7a98bb(options, operations);
    };
}
function $7fc80789f446ee4c$export$24d8b7a10e61e4b7(config) {
    const operationsGenerator = $7fc80789f446ee4c$export$cf82431e47a456ee(config);
    const operationsParser = $7fc80789f446ee4c$export$ac97658230dbc2cb(config);
    return {
        operationsGenerator: operationsGenerator,
        operationsParser: operationsParser
    };
}
function $7fc80789f446ee4c$export$405a0930c3f4dc16(value) {
    if (value === undefined || value === null) return undefined;
    try {
        return Boolean(JSON.parse(value?.toString()));
    } catch  {
        return Boolean(value);
    }
}
const $7fc80789f446ee4c$var$removeUndefined = (obj)=>Object.fromEntries(Object.entries(obj).filter(([, value])=>value !== undefined));
function $7fc80789f446ee4c$export$ed17cc3414a57fef(extract, generate) {
    return (src, operations, options)=>{
        const base = extract(src, options);
        if (!base) return generate(src, operations, options);
        return generate(base.src, {
            ...base.operations,
            ...$7fc80789f446ee4c$var$removeUndefined(operations)
        }, {
            // deno-lint-ignore no-explicit-any
            ...base.options,
            ...options
        });
    };
}


const $b3d17ad6c3624999$var$cdnDomains = new Map(Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($1498aa0bcfcff63f$exports)))));
const $b3d17ad6c3624999$var$cdnSubdomains = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($a6d61df9140eaa4a$exports))));
const $b3d17ad6c3624999$var$cdnPaths = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($d1d0daaba06482b2$exports))));
function $b3d17ad6c3624999$export$b74eb3c64b89e7b4(url) {
    return $b3d17ad6c3624999$export$6b62e37a2f041af8(url) || $b3d17ad6c3624999$export$e75a12846ee69b6e(url);
}
const $b3d17ad6c3624999$export$e1399f03bc6dd3e5 = $b3d17ad6c3624999$export$b74eb3c64b89e7b4;
function $b3d17ad6c3624999$export$6b62e37a2f041af8(url) {
    if (typeof url === "string" && !url.startsWith("https://")) return false;
    const { hostname: hostname } = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const cdn = $b3d17ad6c3624999$var$cdnDomains.get(hostname);
    if (cdn) return cdn;
    return $b3d17ad6c3624999$var$cdnSubdomains.find(([subdomain])=>hostname.endsWith(subdomain))?.[1] || false;
}
const $b3d17ad6c3624999$export$2192df6ac6dfdd0b = $b3d17ad6c3624999$export$6b62e37a2f041af8;
function $b3d17ad6c3624999$export$e75a12846ee69b6e(url) {
    // Allow relative URLs
    const { pathname: pathname } = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    return $b3d17ad6c3624999$var$cdnPaths.find(([path])=>pathname.startsWith(path))?.[1] || false;
}
const $b3d17ad6c3624999$export$7d68d9a65a928724 = $b3d17ad6c3624999$export$e75a12846ee69b6e;




const $60c2c3a42a1591bd$var$VIEW_URL_SUFFIX = "/view?";
const $60c2c3a42a1591bd$var$PREVIEW_URL_SUFFIX = "/preview?";
const { operationsGenerator: $60c2c3a42a1591bd$var$operationsGenerator, operationsParser: $60c2c3a42a1591bd$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        format: "output"
    },
    kvSeparator: "=",
    paramSeparator: "&"
});
const $60c2c3a42a1591bd$export$80d376111cc09ad7 = (src, modifiers)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src.toString().replace($60c2c3a42a1591bd$var$VIEW_URL_SUFFIX, $60c2c3a42a1591bd$var$PREVIEW_URL_SUFFIX));
    const projectParam = url.searchParams.get("project") ?? "";
    const operations = $60c2c3a42a1591bd$var$operationsGenerator(modifiers);
    url.search = operations;
    url.searchParams.append("project", projectParam);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $60c2c3a42a1591bd$export$f9380c9a627682d3 = (url)=>{
    if ((0, $b3d17ad6c3624999$export$e75a12846ee69b6e)(url) !== "appwrite") return null;
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const operations = $60c2c3a42a1591bd$var$operationsParser(parsedUrl);
    // deno-lint-ignore no-explicit-any
    delete operations.project;
    const projectParam = parsedUrl.searchParams.get("project") ?? "";
    parsedUrl.search = "";
    parsedUrl.searchParams.append("project", projectParam);
    const sourceUrl = parsedUrl.href;
    return {
        src: sourceUrl,
        operations: operations
    };
};
const $60c2c3a42a1591bd$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($60c2c3a42a1591bd$export$f9380c9a627682d3, $60c2c3a42a1591bd$export$80d376111cc09ad7);



const $b575084008b0fba0$var$DEFAULT_ENDPOINT = "/_image";
const { operationsParser: $b575084008b0fba0$var$operationsParser, operationsGenerator: $b575084008b0fba0$var$operationsGenerator } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        format: "f",
        width: "w",
        height: "h",
        quality: "q"
    },
    defaults: {
        fit: "cover"
    }
});
const $b575084008b0fba0$export$80d376111cc09ad7 = (src, modifiers, options)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(`${(0, $7fc80789f446ee4c$export$d95b4586d238a081)(options?.baseUrl ?? "")}${options?.endpoint ?? $b575084008b0fba0$var$DEFAULT_ENDPOINT}`);
    const operations = $b575084008b0fba0$var$operationsGenerator(modifiers);
    url.search = operations;
    url.searchParams.set("href", src.toString());
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $b575084008b0fba0$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const src = parsedUrl.searchParams.get("href");
    if (!src) return null;
    parsedUrl.searchParams.delete("href");
    const operations = $b575084008b0fba0$var$operationsParser(parsedUrl);
    return {
        src: src,
        operations: operations,
        options: {
            baseUrl: parsedUrl.origin
        }
    };
};
const $b575084008b0fba0$export$51186ad6e864892a = (src, operations, options = {})=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    if (url.pathname !== (options?.endpoint ?? $b575084008b0fba0$var$DEFAULT_ENDPOINT)) return $b575084008b0fba0$export$80d376111cc09ad7(src, operations, options);
    const base = $b575084008b0fba0$export$f9380c9a627682d3(src);
    if (!base) return $b575084008b0fba0$export$80d376111cc09ad7(src, operations, options);
    options.baseUrl ??= base.options.baseUrl;
    return $b575084008b0fba0$export$80d376111cc09ad7(base.src, {
        ...base.operations,
        ...operations
    }, options);
};



const $ef083e35e12fb11e$var$operationsGenerator = (0, $7fc80789f446ee4c$export$cf82431e47a456ee)({
    defaults: {
        fit: "cover",
        format: "webp",
        sharp: true
    }
});
const $ef083e35e12fb11e$export$f9380c9a627682d3 = (0, $7fc80789f446ee4c$export$3af18ed156c52f8d);
const $ef083e35e12fb11e$export$80d376111cc09ad7 = (src, modifiers)=>{
    const operations = $ef083e35e12fb11e$var$operationsGenerator(modifiers);
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    url.search = operations;
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $ef083e35e12fb11e$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($ef083e35e12fb11e$export$f9380c9a627682d3, $ef083e35e12fb11e$export$80d376111cc09ad7);



const $15146dd326cf0e2c$var$operationsGenerator = (0, $7fc80789f446ee4c$export$cf82431e47a456ee)({
    keyMap: {
        format: "output"
    }
});
const $15146dd326cf0e2c$export$f9380c9a627682d3 = (0, $7fc80789f446ee4c$export$3af18ed156c52f8d);
const $15146dd326cf0e2c$export$80d376111cc09ad7 = (src, modifiers)=>{
    const operations = $15146dd326cf0e2c$var$operationsGenerator(modifiers);
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    url.search = operations;
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $15146dd326cf0e2c$var$extractAndGenerate = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($15146dd326cf0e2c$export$f9380c9a627682d3, $15146dd326cf0e2c$export$80d376111cc09ad7);
const $15146dd326cf0e2c$export$51186ad6e864892a = (src, operations)=>{
    const { width: width, height: height } = operations;
    if (width && height) operations.aspect_ratio ??= `${Math.round(Number(width))}:${Math.round(Number(height))}`;
    return $15146dd326cf0e2c$var$extractAndGenerate(src, operations);
};




const { operationsGenerator: $b40d718d8aa6c68a$var$operationsGenerator, operationsParser: $b40d718d8aa6c68a$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        "format": "f"
    },
    defaults: {
        format: "auto",
        fit: "cover"
    },
    formatMap: {
        jpg: "jpeg"
    },
    kvSeparator: "=",
    paramSeparator: ","
});
const $b40d718d8aa6c68a$export$80d376111cc09ad7 = (src, operations, options)=>{
    const modifiers = $b40d718d8aa6c68a$var$operationsGenerator(operations);
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(options?.domain ? `https://${options.domain}` : "/");
    const srcStr = src.toString();
    let pathSuffix = (0, $7fc80789f446ee4c$export$79c5b1569e3be9e6)(srcStr);
    if (srcStr.startsWith("http") && srcStr.includes("?")) pathSuffix = encodeURIComponent(srcStr);
    url.pathname = `/cdn-cgi/image/${modifiers}/${pathSuffix}`;
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $b40d718d8aa6c68a$export$f9380c9a627682d3 = (url, options)=>{
    if ((0, $b3d17ad6c3624999$export$e75a12846ee69b6e)(url) !== "cloudflare") return null;
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const [, , , modifiers, ...src] = parsedUrl.pathname.split("/");
    const operations = $b40d718d8aa6c68a$var$operationsParser(modifiers);
    return {
        src: (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)((0, $7fc80789f446ee4c$export$1758be3e5622c165)(src.join("/"))),
        operations: operations,
        options: {
            domain: options?.domain ?? (parsedUrl.hostname === "n" ? undefined : parsedUrl.hostname)
        }
    };
};
const $b40d718d8aa6c68a$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($b40d718d8aa6c68a$export$f9380c9a627682d3, $b40d718d8aa6c68a$export$80d376111cc09ad7);



const $2e5a179ef0001d59$var$cloudflareImagesRegex = /https?:\/\/(?<host>[^\/]+)\/cdn-cgi\/imagedelivery\/(?<accountHash>[^\/]+)\/(?<imageId>[^\/]+)\/*(?<transformations>[^\/]+)*$/g;
const $2e5a179ef0001d59$var$imagedeliveryRegex = /https?:\/\/(?<host>imagedelivery.net)\/(?<accountHash>[^\/]+)\/(?<imageId>[^\/]+)\/*(?<transformations>[^\/]+)*$/g;
const { operationsGenerator: $2e5a179ef0001d59$var$operationsGenerator, operationsParser: $2e5a179ef0001d59$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "w",
        height: "h",
        format: "f"
    },
    defaults: {
        fit: "cover"
    },
    kvSeparator: "=",
    paramSeparator: ","
});
function $2e5a179ef0001d59$var$formatUrl(options, transformations) {
    const { host: host, accountHash: accountHash, imageId: imageId } = options;
    if (!host || !accountHash || !imageId) throw new Error("Missing required Cloudflare Images options");
    const pathSegments = [
        "https:/",
        ...host === "imagedelivery.net" ? [
            host
        ] : [
            host,
            "cdn-cgi",
            "imagedelivery"
        ],
        accountHash,
        imageId,
        transformations
    ].filter(Boolean);
    return pathSegments.join("/");
}
const $2e5a179ef0001d59$export$80d376111cc09ad7 = (_src, operations, options = {})=>{
    const transformations = $2e5a179ef0001d59$var$operationsGenerator(operations);
    const url = $2e5a179ef0001d59$var$formatUrl(options, transformations);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)((0, $7fc80789f446ee4c$export$1758be3e5622c165)(url));
};
const $2e5a179ef0001d59$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const matches = [
        ...parsedUrl.toString().matchAll($2e5a179ef0001d59$var$cloudflareImagesRegex),
        ...parsedUrl.toString().matchAll($2e5a179ef0001d59$var$imagedeliveryRegex)
    ];
    if (!matches[0]?.groups) return null;
    const { host: host, accountHash: accountHash, imageId: imageId, transformations: transformations } = matches[0].groups;
    const operations = $2e5a179ef0001d59$var$operationsParser(transformations || "");
    const options = {
        host: host,
        accountHash: accountHash,
        imageId: imageId
    };
    return {
        src: $2e5a179ef0001d59$var$formatUrl(options),
        operations: operations,
        options: options
    };
};
const $2e5a179ef0001d59$export$51186ad6e864892a = (src, operations, options = {})=>{
    const extracted = $2e5a179ef0001d59$export$f9380c9a627682d3(src);
    if (!extracted) throw new Error("Invalid Cloudflare Images URL");
    const newOperations = {
        ...extracted.operations,
        ...operations
    };
    return $2e5a179ef0001d59$export$80d376111cc09ad7(extracted.src, newOperations, {
        ...extracted.options,
        ...options
    });
};




const { operationsGenerator: $c670bc17a8232fd7$var$operationsGenerator, operationsParser: $c670bc17a8232fd7$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        format: "force_format",
        width: "w",
        height: "h",
        quality: "q"
    },
    defaults: {
        org_if_sml: 1
    }
});
const $c670bc17a8232fd7$export$80d376111cc09ad7 = (src, modifiers = {}, { token: token } = {})=>{
    if (!token) throw new Error("Token is required for Cloudimage URLs" + src);
    let srcString = src.toString();
    srcString = srcString.replace(/^https?:\/\//, "");
    if (srcString.includes("?")) {
        modifiers.ci_url_encoded = 1;
        srcString = encodeURIComponent(srcString);
    }
    const operations = $c670bc17a8232fd7$var$operationsGenerator(modifiers);
    const url = new URL(`https://${token}.cloudimg.io/`);
    url.pathname = srcString;
    url.search = operations;
    return url.toString();
};
const $c670bc17a8232fd7$export$f9380c9a627682d3 = (src, options = {})=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    if ((0, $b3d17ad6c3624999$export$b74eb3c64b89e7b4)(url) !== "cloudimage") return null;
    const operations = $c670bc17a8232fd7$var$operationsParser(url);
    let originalSrc = url.pathname;
    if (operations.ci_url_encoded) {
        originalSrc = decodeURIComponent(originalSrc);
        delete operations.ci_url_encoded;
    }
    options.token ??= url.hostname.replace(".cloudimg.io", "");
    return {
        src: `${url.protocol}/${originalSrc}`,
        operations: operations,
        options: options
    };
};
const $c670bc17a8232fd7$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($c670bc17a8232fd7$export$f9380c9a627682d3, $c670bc17a8232fd7$export$80d376111cc09ad7);



const $40535ce10939c9f7$var$publicRegex = /https?:\/\/(?<host>res\.cloudinary\.com)\/(?<cloudName>[a-zA-Z0-9-]+)\/(?<assetType>image|video|raw)\/(?<deliveryType>upload|fetch|private|authenticated|sprite|facebook|twitter|youtube|vimeo)\/?(?<signature>s\-\-[a-zA-Z0-9]+\-\-)?\/?(?<transformations>(?:[^_\/]+_[^,\/]+,?)*)?\/(?:(?<version>v\d+)\/)?(?<id>(?:[^\s\/]+\/)*[^\s\/]+(?:\.[a-zA-Z0-9]+)?)$/;
const $40535ce10939c9f7$var$privateRegex = /https?:\/\/(?<host>(?<cloudName>[a-zA-Z0-9-]+)-res\.cloudinary\.com|[a-zA-Z0-9.-]+)\/(?<assetType>image|video|raw)\/(?<deliveryType>upload|fetch|private|authenticated|sprite|facebook|twitter|youtube|vimeo)\/?(?<signature>s\-\-[a-zA-Z0-9]+\-\-)?\/?(?<transformations>(?:[^_\/]+_[^,\/]+,?)*)?\/(?:(?<version>v\d+)\/)?(?<id>(?:[^\s\/]+\/)*[^\s\/]+(?:\.[a-zA-Z0-9]+)?)$/;
const { operationsGenerator: $40535ce10939c9f7$var$operationsGenerator, operationsParser: $40535ce10939c9f7$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "w",
        height: "h",
        format: "f",
        quality: "q"
    },
    defaults: {
        format: "auto",
        c: "lfill"
    },
    kvSeparator: "_",
    paramSeparator: ","
});
const $40535ce10939c9f7$export$80d376111cc09ad7 = (src, operations)=>{
    const group = $40535ce10939c9f7$var$parseCloudinaryUrl(src.toString());
    if (!group) return src.toString();
    group.transformations = $40535ce10939c9f7$var$operationsGenerator(operations);
    return $40535ce10939c9f7$var$formatCloudinaryUrl(group);
};
function $40535ce10939c9f7$var$formatCloudinaryUrl({ host: host, cloudName: cloudName, assetType: assetType, deliveryType: deliveryType, signature: signature, transformations: transformations, version: version, id: id }) {
    const isPublic = host === "res.cloudinary.com";
    return [
        "https:/",
        host,
        isPublic ? cloudName : undefined,
        assetType,
        deliveryType,
        signature,
        transformations,
        version,
        id
    ].filter(Boolean).join("/");
}
function $40535ce10939c9f7$var$parseCloudinaryUrl(url) {
    let matches = url.toString().match($40535ce10939c9f7$var$publicRegex);
    if (!matches?.length) matches = url.toString().match($40535ce10939c9f7$var$privateRegex);
    if (!matches?.length) return null;
    return matches.groups || {};
}
const $40535ce10939c9f7$export$f9380c9a627682d3 = (url)=>{
    const group = $40535ce10939c9f7$var$parseCloudinaryUrl(url.toString());
    if (!group) return null;
    const { transformations: transformString = "", ...params } = group;
    const src = $40535ce10939c9f7$var$formatCloudinaryUrl(params);
    const operations = $40535ce10939c9f7$var$operationsParser(transformString) || {};
    return {
        src: src,
        operations: operations,
        options: {
            cloudName: params.cloudName,
            domain: params.host,
            privateCdn: params.host !== "res.cloudinary.com"
        }
    };
};
const $40535ce10939c9f7$export$51186ad6e864892a = (src, operations)=>{
    const group = $40535ce10939c9f7$var$parseCloudinaryUrl(src.toString());
    if (!group) return src.toString();
    const existing = $40535ce10939c9f7$var$operationsParser(group.transformations || "");
    group.transformations = $40535ce10939c9f7$var$operationsGenerator({
        ...existing,
        ...operations
    });
    return $40535ce10939c9f7$var$formatCloudinaryUrl(group);
};



const $0eb0a3f2f31ee582$var$operationsGenerator = (0, $7fc80789f446ee4c$export$cf82431e47a456ee)({
    keyMap: {
        format: "fm",
        width: "w",
        height: "h",
        quality: "q"
    },
    defaults: {
        fit: "fill"
    }
});
const $0eb0a3f2f31ee582$export$80d376111cc09ad7 = (src, modifiers)=>{
    const operations = $0eb0a3f2f31ee582$var$operationsGenerator(modifiers);
    const url = new URL(src);
    url.search = operations;
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $0eb0a3f2f31ee582$export$f9380c9a627682d3 = (0, $7fc80789f446ee4c$export$3af18ed156c52f8d);
const $0eb0a3f2f31ee582$var$extractAndGenerate = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($0eb0a3f2f31ee582$export$f9380c9a627682d3, $0eb0a3f2f31ee582$export$80d376111cc09ad7);
const $0eb0a3f2f31ee582$export$51186ad6e864892a = (src, operations)=>{
    const { width: width, height: height } = (0, $7fc80789f446ee4c$export$b2d1ff673228dec6)(operations, 4000, 4000);
    return $0eb0a3f2f31ee582$var$extractAndGenerate(src, {
        ...operations,
        width: width,
        height: height
    });
};



const $b2e5a4418abc5d00$var$operationsGenerator = (0, $7fc80789f446ee4c$export$cf82431e47a456ee)({
    defaults: {
        auto: "webp",
        disable: "upscale"
    }
});
const $b2e5a4418abc5d00$export$80d376111cc09ad7 = (src, operations, { baseURL: baseURL = "https://images.contentstack.io/" } = {})=>{
    if (operations.width && operations.height) operations.fit ??= "crop";
    const modifiers = $b2e5a4418abc5d00$var$operationsGenerator(operations);
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    if (url.hostname === "n") {
        url.protocol = "https:";
        url.hostname = new URL(baseURL).hostname;
    }
    url.search = modifiers;
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $b2e5a4418abc5d00$export$f9380c9a627682d3 = (url)=>{
    const { src: src, operations: operations } = (0, $7fc80789f446ee4c$export$3af18ed156c52f8d)(url) ?? {};
    if (!operations || !src) return null;
    const { origin: origin } = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    return {
        src: src,
        operations: operations,
        options: {
            baseURL: origin
        }
    };
};
const $b2e5a4418abc5d00$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($b2e5a4418abc5d00$export$f9380c9a627682d3, $b2e5a4418abc5d00$export$80d376111cc09ad7);



const $ab3e54b82570deb1$var$operationsGenerator = (0, $7fc80789f446ee4c$export$cf82431e47a456ee)({
    defaults: {
        withoutEnlargement: true,
        fit: "cover"
    }
});
const $ab3e54b82570deb1$export$80d376111cc09ad7 = (src, operations)=>{
    if (Array.isArray(operations.transforms)) operations.transforms = JSON.stringify(operations.transforms);
    const modifiers = $ab3e54b82570deb1$var$operationsGenerator(operations);
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    url.search = modifiers;
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $ab3e54b82570deb1$export$f9380c9a627682d3 = (url)=>{
    const base = (0, $7fc80789f446ee4c$export$3af18ed156c52f8d)(url);
    if (base?.operations?.transforms && typeof base.operations.transforms === "string") try {
        base.operations.transforms = JSON.parse(base.operations.transforms);
    } catch  {
        return null;
    }
    return base;
};
const $ab3e54b82570deb1$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($ab3e54b82570deb1$export$f9380c9a627682d3, $ab3e54b82570deb1$export$80d376111cc09ad7);



const $b192cd11847635f9$var$hygraphRegex = /https:\/\/(?<region>[a-z0-9-]+)\.graphassets\.com\/(?<envId>[a-zA-Z0-9]+)(?:\/(?<transformations>.*?))?\/(?<handle>[a-zA-Z0-9]+)$/;
const { operationsGenerator: $b192cd11847635f9$var$operationsGenerator, operationsParser: $b192cd11847635f9$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "width",
        height: "height",
        format: "format"
    },
    defaults: {
        format: "auto",
        fit: "crop"
    }
});
const $b192cd11847635f9$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const matches = parsedUrl.toString().match($b192cd11847635f9$var$hygraphRegex);
    if (!matches?.groups) return null;
    const { region: region, envId: envId, handle: handle, transformations: transformations } = matches.groups;
    // Parse any existing transformations from the URL
    const operations = {};
    if (transformations) {
        const parts = transformations.split("/");
        parts.forEach((part)=>{
            const [operation, params] = part.split("=");
            if (operation === "resize" && params) params.split(",").forEach((param)=>{
                const [key, value] = param.split(":");
                if (key === "width" || key === "height") operations[key] = Number(value);
                else if (key === "fit") operations.fit = value;
            });
            else if (operation === "output" && params) params.split(",").forEach((param)=>{
                const [key, value] = param.split(":");
                if (key === "format") operations.format = value;
            });
            else if (operation === "auto_image") operations.format = "auto";
        });
    }
    return {
        src: `https://${region}.graphassets.com/${envId}/${handle}`,
        operations: operations,
        options: {
            region: region,
            envId: envId,
            handle: handle
        }
    };
};
const $b192cd11847635f9$export$80d376111cc09ad7 = (src, operations, options = {})=>{
    // First extract the components from the source URL
    const extracted = $b192cd11847635f9$export$f9380c9a627682d3(src);
    if (!extracted) throw new Error("Invalid Hygraph URL");
    // Merge options
    const { region: region, envId: envId, handle: handle } = {
        ...extracted.options,
        ...options
    };
    const transforms = [];
    // Add resize transformation if width or height is specified
    if (operations.width || operations.height) {
        const resize = [];
        // Always include fit:crop when both dimensions are specified to maintain aspect ratio
        if (operations.width && operations.height) resize.push("fit:crop");
        else if (operations.fit) resize.push(`fit:${operations.fit}`);
        if (operations.width) resize.push(`width:${operations.width}`);
        if (operations.height) resize.push(`height:${operations.height}`);
        if (resize.length) transforms.push(`resize=${resize.join(",")}`);
    }
    // Add format transformation
    if (operations.format === "auto" || !operations.format && !extracted.operations.format) transforms.push("auto_image");
    else if (operations.format) transforms.push(`output=format:${operations.format}`);
    // Construct the URL in parts
    const baseUrl = `https://${region}.graphassets.com/${envId}`;
    const transformPart = transforms.length > 0 ? "/" + transforms.join("/") : "";
    const finalUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(`${baseUrl}${transformPart}/${handle}`);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(finalUrl);
};
const $b192cd11847635f9$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($b192cd11847635f9$export$f9380c9a627682d3, $b192cd11847635f9$export$80d376111cc09ad7);



const { operationsGenerator: $c33d1d6e207c23fc$var$operationsGenerator, operationsParser: $c33d1d6e207c23fc$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "w",
        height: "h",
        format: "f"
    },
    defaults: {
        m: "cropbox"
    },
    kvSeparator: "_",
    paramSeparator: "/"
});
const $c33d1d6e207c23fc$export$80d376111cc09ad7 = (src, operations)=>{
    const modifiers = $c33d1d6e207c23fc$var$operationsGenerator(operations);
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    url.searchParams.set("imgeng", modifiers);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $c33d1d6e207c23fc$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const imgeng = parsedUrl.searchParams.get("imgeng");
    if (!imgeng) return null;
    const operations = $c33d1d6e207c23fc$var$operationsParser(imgeng);
    parsedUrl.searchParams.delete("imgeng");
    return {
        src: (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(parsedUrl),
        operations: operations
    };
};
const $c33d1d6e207c23fc$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($c33d1d6e207c23fc$export$f9380c9a627682d3, $c33d1d6e207c23fc$export$80d376111cc09ad7);



const { operationsGenerator: $733dde3329e4fce8$var$operationsGenerator, operationsParser: $733dde3329e4fce8$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "w",
        height: "h",
        format: "f",
        quality: "q"
    },
    defaults: {
        c: "maintain_ratio",
        fo: "auto"
    },
    kvSeparator: "-",
    paramSeparator: ","
});
const $733dde3329e4fce8$export$80d376111cc09ad7 = (src, operations)=>{
    const modifiers = $733dde3329e4fce8$var$operationsGenerator(operations);
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    url.searchParams.set("tr", modifiers);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $733dde3329e4fce8$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    let trPart = null;
    let path = parsedUrl.pathname;
    // Check for query parameter format
    if (parsedUrl.searchParams.has("tr")) {
        trPart = parsedUrl.searchParams.get("tr");
        parsedUrl.searchParams.delete("tr");
    } else {
        // Check for path-based format
        const pathParts = parsedUrl.pathname.split("/");
        const trIndex = pathParts.findIndex((part)=>part.startsWith("tr:"));
        if (trIndex !== -1) {
            trPart = pathParts[trIndex].slice(3); // Remove 'tr:' prefix
            path = pathParts.slice(0, trIndex).concat(pathParts.slice(trIndex + 1)).join("/");
        }
    }
    if (!trPart) return null;
    parsedUrl.pathname = path;
    const operations = $733dde3329e4fce8$var$operationsParser(trPart);
    return {
        src: (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(parsedUrl),
        operations: operations
    };
};
const $733dde3329e4fce8$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($733dde3329e4fce8$export$f9380c9a627682d3, $733dde3329e4fce8$export$80d376111cc09ad7);



const { operationsGenerator: $e334b29624873677$var$operationsGenerator, operationsParser: $e334b29624873677$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        format: "fm",
        width: "w",
        height: "h",
        quality: "q"
    },
    defaults: {
        fit: "min",
        auto: "format"
    }
});
const $e334b29624873677$export$f9380c9a627682d3 = (url)=>{
    const src = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const operations = $e334b29624873677$var$operationsParser(url);
    src.search = "";
    return {
        src: (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(src),
        operations: operations
    };
};
const $e334b29624873677$export$80d376111cc09ad7 = (src, operations)=>{
    const modifiers = $e334b29624873677$var$operationsGenerator(operations);
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    url.search = modifiers;
    if (url.searchParams.has("fm") && url.searchParams.get("auto") === "format") url.searchParams.delete("auto");
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $e334b29624873677$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($e334b29624873677$export$f9380c9a627682d3, $e334b29624873677$export$80d376111cc09ad7);



const { operationsGenerator: $bea2dd7c9fdc3169$var$operationsGenerator, operationsParser: $bea2dd7c9fdc3169$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "w",
        height: "h",
        quality: "q",
        format: "f"
    },
    defaults: {
        f: "auto"
    },
    kvSeparator: "_",
    paramSeparator: ","
});
const $bea2dd7c9fdc3169$export$80d376111cc09ad7 = (src, operations, options)=>{
    if (operations.width && operations.height) {
        operations.s = `${operations.width}x${operations.height}`;
        delete operations.width;
        delete operations.height;
    }
    const modifiers = $bea2dd7c9fdc3169$var$operationsGenerator(operations);
    const baseURL = options?.baseURL ?? "/_ipx";
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(baseURL);
    url.pathname = `${(0, $7fc80789f446ee4c$export$d95b4586d238a081)(url.pathname)}/${modifiers}/${(0, $7fc80789f446ee4c$export$79c5b1569e3be9e6)(src.toString())}`;
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $bea2dd7c9fdc3169$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const [, baseUrlPart, modifiers, ...srcParts] = parsedUrl.pathname.split("/");
    if (!modifiers || !srcParts.length) return null;
    const operations = $bea2dd7c9fdc3169$var$operationsParser(modifiers);
    // Handle the 's' parameter
    if (operations.s) {
        const [width, height] = operations.s.split("x").map(Number);
        operations.width = width;
        operations.height = height;
        delete operations.s;
    }
    return {
        src: "/" + srcParts.join("/"),
        operations: operations,
        options: {
            baseURL: `${parsedUrl.origin}/${baseUrlPart}`
        }
    };
};
const $bea2dd7c9fdc3169$export$51186ad6e864892a = (src, operations, options)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    const baseURL = options?.baseURL;
    if (baseURL && url.toString().startsWith(baseURL) || url.pathname.startsWith("/_ipx")) {
        const extracted = $bea2dd7c9fdc3169$export$f9380c9a627682d3(src);
        if (extracted) return $bea2dd7c9fdc3169$export$80d376111cc09ad7(extracted.src, {
            ...extracted.operations,
            ...operations
        }, {
            baseURL: extracted.options.baseURL
        });
    }
    return $bea2dd7c9fdc3169$export$80d376111cc09ad7(src, operations, {
        baseURL: baseURL
    });
};



const $9614c2ac2f9d2894$var$BOOLEAN_PARAMS = [
    "enlarge",
    "flip",
    "flop",
    "negate",
    "normalize",
    "grayscale",
    "removealpha",
    "olrepeat",
    "progressive",
    "adaptive",
    "lossless",
    "nearlossless",
    "metadata"
];
const { operationsGenerator: $9614c2ac2f9d2894$var$operationsGenerator, operationsParser: $9614c2ac2f9d2894$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    defaults: {
        fit: "cover"
    },
    formatMap: {
        jpg: "jpeg"
    }
});
const $9614c2ac2f9d2894$export$80d376111cc09ad7 = (src, operations)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    for (const key of $9614c2ac2f9d2894$var$BOOLEAN_PARAMS)if (operations[key] !== undefined) operations[key] = operations[key] ? 1 : 0;
    url.search = $9614c2ac2f9d2894$var$operationsGenerator(operations);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $9614c2ac2f9d2894$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const operations = $9614c2ac2f9d2894$var$operationsParser(parsedUrl);
    for (const key of $9614c2ac2f9d2894$var$BOOLEAN_PARAMS)if (operations[key] !== undefined) operations[key] = (0, $7fc80789f446ee4c$export$405a0930c3f4dc16)(operations[key]);
    parsedUrl.search = "";
    return {
        src: (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(parsedUrl),
        operations: operations
    };
};
const $9614c2ac2f9d2894$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($9614c2ac2f9d2894$export$f9380c9a627682d3, $9614c2ac2f9d2894$export$80d376111cc09ad7);



const { operationsGenerator: $ca9a9f4f1852b9c1$var$operationsGenerator, operationsParser: $ca9a9f4f1852b9c1$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    formatMap: {
        jpg: "jpeg"
    },
    keyMap: {
        format: "fm",
        width: "w",
        height: "h",
        quality: "q"
    }
});
const $ca9a9f4f1852b9c1$export$80d376111cc09ad7 = (src, operations)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    if (operations.lossless !== undefined) operations.lossless = operations.lossless ? 1 : 0;
    if (operations.width && operations.height) operations.fit = "crop";
    url.search = $ca9a9f4f1852b9c1$var$operationsGenerator(operations);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $ca9a9f4f1852b9c1$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const operations = $ca9a9f4f1852b9c1$var$operationsParser(parsedUrl);
    if (operations.lossless !== undefined) operations.lossless = (0, $7fc80789f446ee4c$export$405a0930c3f4dc16)(operations.lossless);
    parsedUrl.search = "";
    return {
        src: (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(parsedUrl),
        operations: operations
    };
};
const $ca9a9f4f1852b9c1$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($ca9a9f4f1852b9c1$export$f9380c9a627682d3, $ca9a9f4f1852b9c1$export$80d376111cc09ad7);




const { operationsGenerator: $8d164ef40fd3ad1c$var$operationsGenerator, operationsParser: $8d164ef40fd3ad1c$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    defaults: {
        fit: "cover"
    },
    keyMap: {
        format: "fm",
        width: "w",
        height: "h",
        quality: "q"
    }
});
const $8d164ef40fd3ad1c$export$80d376111cc09ad7 = (src, operations, options = {})=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(`${options.baseUrl || ""}/.netlify/images`);
    url.search = $8d164ef40fd3ad1c$var$operationsGenerator(operations);
    url.searchParams.set("url", src.toString());
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $8d164ef40fd3ad1c$export$f9380c9a627682d3 = (url)=>{
    if ((0, $b3d17ad6c3624999$export$e75a12846ee69b6e)(url) !== "netlify") return null;
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const operations = $8d164ef40fd3ad1c$var$operationsParser(parsedUrl);
    // deno-lint-ignore no-explicit-any
    delete operations.url;
    const sourceUrl = parsedUrl.searchParams.get("url") || "";
    parsedUrl.search = "";
    return {
        src: sourceUrl,
        operations: operations,
        options: {
            baseUrl: parsedUrl.hostname === "n" ? undefined : parsedUrl.origin
        }
    };
};
const $8d164ef40fd3ad1c$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($8d164ef40fd3ad1c$export$f9380c9a627682d3, $8d164ef40fd3ad1c$export$80d376111cc09ad7);




const { operationsGenerator: $7cdce42a27092b75$var$operationsGenerator, operationsParser: $7cdce42a27092b75$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "w",
        quality: "q",
        height: false,
        format: false
    },
    defaults: {
        q: 75
    }
});
const $7cdce42a27092b75$export$80d376111cc09ad7 = (src, operations, options = {})=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(`${options.baseUrl || ""}/${options.prefix || "_vercel"}/image`);
    url.search = $7cdce42a27092b75$var$operationsGenerator(operations);
    url.searchParams.append("url", src.toString());
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $7cdce42a27092b75$export$f9380c9a627682d3 = (url, options = {})=>{
    if (![
        "vercel",
        "nextjs"
    ].includes((0, $b3d17ad6c3624999$export$e75a12846ee69b6e)(url) || "")) return null;
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const sourceUrl = parsedUrl.searchParams.get("url") || "";
    parsedUrl.searchParams.delete("url");
    const operations = $7cdce42a27092b75$var$operationsParser(parsedUrl);
    parsedUrl.search = "";
    return {
        src: sourceUrl,
        operations: operations,
        options: {
            baseUrl: options.baseUrl ?? parsedUrl.origin
        }
    };
};
const $7cdce42a27092b75$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($7cdce42a27092b75$export$f9380c9a627682d3, $7cdce42a27092b75$export$80d376111cc09ad7);



const $dd42ee47c04381cf$export$80d376111cc09ad7 = (src, operations, options = {})=>(0, $7cdce42a27092b75$export$80d376111cc09ad7)(src, operations, {
        ...options,
        prefix: "_next"
    });
const $dd42ee47c04381cf$export$f9380c9a627682d3 = (url, options)=>(0, $7cdce42a27092b75$export$f9380c9a627682d3)(url, options);
const $dd42ee47c04381cf$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($dd42ee47c04381cf$export$f9380c9a627682d3, $dd42ee47c04381cf$export$80d376111cc09ad7);




const { operationsGenerator: $d8d1ce1feb92dd01$var$operationsGenerator, operationsParser: $d8d1ce1feb92dd01$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "wid",
        height: "hei",
        quality: "qlt",
        format: "fmt"
    },
    defaults: {
        fit: "crop,0"
    }
});
const $d8d1ce1feb92dd01$var$BASE = "https://s7d1.scene7.com/is/image/";
const $d8d1ce1feb92dd01$export$80d376111cc09ad7 = (src, operations)=>{
    const url = new URL(src, $d8d1ce1feb92dd01$var$BASE);
    url.search = $d8d1ce1feb92dd01$var$operationsGenerator(operations);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $d8d1ce1feb92dd01$export$f9380c9a627682d3 = (url)=>{
    if ((0, $b3d17ad6c3624999$export$b74eb3c64b89e7b4)(url) !== "scene7") return null;
    const parsedUrl = new URL(url, $d8d1ce1feb92dd01$var$BASE);
    const operations = $d8d1ce1feb92dd01$var$operationsParser(parsedUrl);
    parsedUrl.search = "";
    return {
        src: parsedUrl.toString(),
        operations: operations
    };
};
const $d8d1ce1feb92dd01$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($d8d1ce1feb92dd01$export$f9380c9a627682d3, $d8d1ce1feb92dd01$export$80d376111cc09ad7);



const $bbe9f58116cfab10$var$shopifyRegex = /(.+?)(?:_(?:(pico|icon|thumb|small|compact|medium|large|grande|original|master)|(\d*)x(\d*)))?(?:_crop_([a-z]+))?(\.[a-zA-Z]+)(\.png|\.jpg|\.webp|\.avif)?$/;
const { operationsGenerator: $bbe9f58116cfab10$var$operationsGenerator, operationsParser: $bbe9f58116cfab10$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        format: false
    }
});
const $bbe9f58116cfab10$export$80d376111cc09ad7 = (src, operations)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    const basePath = url.pathname.replace($bbe9f58116cfab10$var$shopifyRegex, "$1$6");
    // Update pathname with the clean version (remove size details)
    url.pathname = basePath;
    // Add query parameters for size, format, etc.
    url.search = $bbe9f58116cfab10$var$operationsGenerator(operations);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $bbe9f58116cfab10$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const match = $bbe9f58116cfab10$var$shopifyRegex.exec(parsedUrl.pathname);
    const operations = $bbe9f58116cfab10$var$operationsParser(parsedUrl);
    if (match) {
        const [, , , width, height, crop] = match;
        if (width && height && !operations.width && !operations.height) {
            operations.width = parseInt(width, 10);
            operations.height = parseInt(height, 10);
        }
        if (crop) operations.crop ??= crop;
    }
    const basePath = parsedUrl.pathname.replace($bbe9f58116cfab10$var$shopifyRegex, "$1$6");
    parsedUrl.pathname = basePath;
    for (const key of [
        "width",
        "height",
        "crop",
        "pad_color",
        "format"
    ])parsedUrl.searchParams.delete(key);
    return {
        src: parsedUrl.toString(),
        operations: operations
    };
};
const $bbe9f58116cfab10$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($bbe9f58116cfab10$export$f9380c9a627682d3, $bbe9f58116cfab10$export$80d376111cc09ad7);



const $b2b7de334e9aa1c8$var$storyBlokAssets = /(?<id>\/f\/\d+\/\d+x\d+\/\w+\/[^\/]+)\/?(?<modifiers>m\/?(?<crop>\d+x\d+:\d+x\d+)?\/?(?<resize>(?<flipx>\-)?(?<width>\d+)x(?<flipy>\-)?(?<height>\d+))?\/?(filters\:(?<filters>[^\/]+))?)?$/;
const $b2b7de334e9aa1c8$var$storyBlokImg2 = /^(?<modifiers>\/(?<crop>\d+x\d+:\d+x\d+)?\/?(?<resize>(?<flipx>\-)?(?<width>\d+)x(?<flipy>\-)?(?<height>\d+))?\/?(filters\:(?<filters>[^\/]+))?\/?)?(?<id>\/f\/.+)$/;
// This regex selects every colon(:) that is not inside parentheses. So that focal(150x150:250x250) is not split into two filters.
const $b2b7de334e9aa1c8$var$filterSplitterRegex = /:(?![^(]*\))/;
const $b2b7de334e9aa1c8$var$splitFilters = (filters)=>{
    if (!filters) return {};
    return Object.fromEntries(filters.split($b2b7de334e9aa1c8$var$filterSplitterRegex).map((filter)=>{
        if (!filter) return [];
        const [key, value] = filter.split("(");
        return [
            key,
            value.replace(")", "")
        ];
    }));
};
const $b2b7de334e9aa1c8$var$generateFilters = (filters)=>{
    if (!filters) return undefined;
    const filterItems = Object.entries(filters).map(([key, value])=>`${key}(${value ?? ""})`);
    if (filterItems.length === 0) return undefined;
    return `filters:${filterItems.join(":")}`;
};
const $b2b7de334e9aa1c8$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const regex = parsedUrl.hostname === "img2.storyblok.com" ? $b2b7de334e9aa1c8$var$storyBlokImg2 : $b2b7de334e9aa1c8$var$storyBlokAssets;
    const matches = regex.exec(parsedUrl.pathname);
    if (!matches || !matches.groups) return null;
    const { id: id, crop: crop, width: width, height: height, filters: filters, flipx: flipx, flipy: flipy } = matches.groups;
    const { format: format, ...filterMap } = $b2b7de334e9aa1c8$var$splitFilters(filters ?? "");
    // We update old img2.storyblok.com URLs to use the new syntax and domain
    if (parsedUrl.hostname === "img2.storyblok.com") parsedUrl.hostname = "a.storyblok.com";
    const operations = Object.fromEntries([
        [
            "width",
            Number(width) || undefined
        ],
        [
            "height",
            Number(height) || undefined
        ],
        [
            "format",
            format
        ],
        [
            "crop",
            crop
        ],
        [
            "filters",
            filterMap
        ],
        [
            "flipx",
            flipx
        ],
        [
            "flipy",
            flipy
        ]
    ].filter(([_, value])=>value !== undefined));
    return {
        src: `${parsedUrl.origin}${id}`,
        operations: operations
    };
};
const $b2b7de334e9aa1c8$export$80d376111cc09ad7 = (src, operations)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    const { width: width = 0, height: height = 0, format: format, crop: crop, filters: filters = {}, flipx: flipx = "", flipy: flipy = "" } = operations;
    const size = `${flipx}${width}x${flipy}${height}`;
    if (format) filters.format = format;
    const parts = [
        url.pathname,
        "m",
        crop,
        size,
        $b2b7de334e9aa1c8$var$generateFilters(filters)
    ].filter(Boolean);
    url.pathname = parts.join("/");
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $b2b7de334e9aa1c8$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($b2b7de334e9aa1c8$export$f9380c9a627682d3, $b2b7de334e9aa1c8$export$80d376111cc09ad7);



const $ecc2ae357e45815a$var$STORAGE_URL_PREFIX = "/storage/v1/object/public/";
const $ecc2ae357e45815a$var$RENDER_URL_PREFIX = "/storage/v1/render/image/public/";
const $ecc2ae357e45815a$var$isRenderUrl = (url)=>url.pathname.startsWith($ecc2ae357e45815a$var$RENDER_URL_PREFIX);
const { operationsGenerator: $ecc2ae357e45815a$var$operationsGenerator, operationsParser: $ecc2ae357e45815a$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({});
const $ecc2ae357e45815a$export$80d376111cc09ad7 = (src, operations)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    const basePath = url.pathname.replace($ecc2ae357e45815a$var$RENDER_URL_PREFIX, $ecc2ae357e45815a$var$STORAGE_URL_PREFIX);
    // Update the pathname with the cleaned version
    url.pathname = basePath;
    // Supabase uses auto-format unless set to origin. Specific formats are not supported
    if (operations.format && operations.format !== "origin") delete operations.format;
    // Add query parameters for image transformation
    url.search = $ecc2ae357e45815a$var$operationsGenerator(operations);
    // Replace with the render prefix for rendering
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url).replace($ecc2ae357e45815a$var$STORAGE_URL_PREFIX, $ecc2ae357e45815a$var$RENDER_URL_PREFIX);
};
const $ecc2ae357e45815a$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const operations = $ecc2ae357e45815a$var$operationsParser(parsedUrl);
    const isRender = $ecc2ae357e45815a$var$isRenderUrl(parsedUrl);
    const imagePath = parsedUrl.pathname.replace($ecc2ae357e45815a$var$RENDER_URL_PREFIX, "").replace($ecc2ae357e45815a$var$STORAGE_URL_PREFIX, "");
    if (!isRender) return {
        src: (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(parsedUrl),
        operations: operations
    };
    return {
        src: `${parsedUrl.origin}${$ecc2ae357e45815a$var$STORAGE_URL_PREFIX}${imagePath}`,
        operations: operations
    };
};
const $ecc2ae357e45815a$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($ecc2ae357e45815a$export$f9380c9a627682d3, $ecc2ae357e45815a$export$80d376111cc09ad7);



const { operationsGenerator: $a31e1c0a1463f77f$var$operationsGenerator, operationsParser: $a31e1c0a1463f77f$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "w",
        height: "h",
        format: "f",
        quality: "q"
    },
    // The service answers `jpg`, not `jpeg`, and silently ignores a format it
    // does not know — so an unmapped `jpeg` would return the source format with
    // a 200 and no way to tell why.
    formatMap: {
        jpeg: "jpg"
    }
});
/**
 * `/i/<pid>/…` is the only shape this provider handles. The pid pattern is the
 * service's own (3-64 lowercase alphanumerics and dashes); matching it rather
 * than just `/i/` keeps the provider from claiming an unrelated URL on a custom
 * domain that happens to have an `/i/` directory.
 */ const $a31e1c0a1463f77f$var$DELIVERY_PATH = /^\/i\/[a-z0-9][a-z0-9-]{2,63}\/.+/;
/**
 * Parameters come out sorted by name.
 *
 * The service accepts any order, but every other builder of this contract emits
 * them sorted, and two orderings of one request are two CDN cache entries for
 * the same image.
 */ function $a31e1c0a1463f77f$var$sortSearch(url) {
    const sorted = [
        ...url.searchParams.entries()
    ].sort(([a], [b])=>a < b ? -1 : a > b ? 1 : 0);
    url.search = "";
    for (const [key, value] of sorted)url.searchParams.append(key, value);
    // The transformation engine does not decode `%2C`, so `crop=60,30,0,0` has
    // to keep its commas literal or the crop is ignored and the image comes
    // back uncropped, with a 200.
    url.search = url.search.replace(/%2C/g, ",");
}
const $a31e1c0a1463f77f$export$f9380c9a627682d3 = (url)=>{
    const src = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    if (!$a31e1c0a1463f77f$var$DELIVERY_PATH.test(src.pathname)) return null;
    const operations = $a31e1c0a1463f77f$var$operationsParser(url);
    // `s` and `exp` are an HMAC over this exact path and query. Returning them
    // as operations would let a caller regenerate a URL carrying a signature
    // that no longer covers it.
    delete operations.s;
    delete operations.exp;
    src.search = "";
    return {
        src: (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(src),
        operations: operations
    };
};
const $a31e1c0a1463f77f$export$80d376111cc09ad7 = (src, operations)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    url.search = $a31e1c0a1463f77f$var$operationsGenerator(operations);
    $a31e1c0a1463f77f$var$sortSearch(url);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $a31e1c0a1463f77f$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($a31e1c0a1463f77f$export$f9380c9a627682d3, $a31e1c0a1463f77f$export$80d376111cc09ad7);



const $b28c18204baa06d6$var$uploadcareRegex = /^https?:\/\/(?<host>[^\/]+)\/(?<uuid>[^\/]+)(?:\/(?<filename>[^\/]+)?)?/;
const { operationsGenerator: $b28c18204baa06d6$var$operationsGenerator, operationsParser: $b28c18204baa06d6$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: false,
        height: false
    },
    defaults: {
        format: "auto"
    },
    kvSeparator: "/",
    paramSeparator: "/-/"
});
const $b28c18204baa06d6$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const match = $b28c18204baa06d6$var$uploadcareRegex.exec(parsedUrl.toString());
    if (!match || !match.groups) return null;
    const { host: host, uuid: uuid } = match.groups;
    const [, ...operationsString] = parsedUrl.pathname.split("/-/");
    const operations = $b28c18204baa06d6$var$operationsParser(operationsString.join("/-/") || "");
    if (operations.resize) {
        const [width, height] = operations.resize.split("x");
        if (width) operations.width = parseInt(width);
        if (height) operations.height = parseInt(height);
        delete operations.resize;
    }
    return {
        src: `https://${host}/${uuid}/`,
        operations: operations,
        options: {
            host: host
        }
    };
};
const $b28c18204baa06d6$export$80d376111cc09ad7 = (src, operations, options = {})=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    const host = options.host || url.hostname;
    // Strip filename from the URL
    const match = $b28c18204baa06d6$var$uploadcareRegex.exec(url.toString());
    if (match?.groups) url.pathname = `/${match.groups.uuid}/`;
    operations.resize = operations.resize || `${operations.width ?? ""}x${operations.height ?? ""}`;
    delete operations.width;
    delete operations.height;
    const modifiers = (0, $7fc80789f446ee4c$export$5899956e46ffac7a)($b28c18204baa06d6$var$operationsGenerator(operations));
    url.hostname = host;
    url.pathname = (0, $7fc80789f446ee4c$export$d95b4586d238a081)(url.pathname) + (modifiers ? `/-/${modifiers}` : "") + (match?.groups?.filename ?? "");
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $b28c18204baa06d6$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($b28c18204baa06d6$export$f9380c9a627682d3, $b28c18204baa06d6$export$80d376111cc09ad7);




const { operationsGenerator: $b989e946d7b3952c$var$operationsGenerator, operationsParser: $b989e946d7b3952c$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "w",
        height: "h"
    },
    defaults: {
        crop: "1"
    }
});
const $b989e946d7b3952c$export$80d376111cc09ad7 = (src, operations)=>{
    const url = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(src);
    const { crop: crop } = operations;
    if (typeof crop !== "undefined" && crop !== "0") operations.crop = crop ? "1" : "0";
    url.search = $b989e946d7b3952c$var$operationsGenerator(operations);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $b989e946d7b3952c$export$f9380c9a627682d3 = (url)=>{
    const parsedUrl = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const operations = $b989e946d7b3952c$var$operationsParser(parsedUrl);
    if (operations.crop !== undefined) operations.crop = operations.crop === "1";
    parsedUrl.search = "";
    return {
        src: (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(parsedUrl),
        operations: operations
    };
};
const $b989e946d7b3952c$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($b989e946d7b3952c$export$f9380c9a627682d3, $b989e946d7b3952c$export$80d376111cc09ad7);



const { operationsGenerator: $f0811e54c17867e6$var$operationsGenerator, operationsParser: $f0811e54c17867e6$var$operationsParser } = (0, $7fc80789f446ee4c$export$24d8b7a10e61e4b7)({
    keyMap: {
        width: "w",
        height: "h",
        format: "output",
        quality: "q"
    },
    defaults: {
        fit: "cover"
    }
});
const $f0811e54c17867e6$export$f9380c9a627682d3 = (url)=>{
    const urlObj = (0, $7fc80789f446ee4c$export$1758be3e5622c165)(url);
    const srcParam = urlObj.searchParams.get("url");
    if (!srcParam) return null;
    let src = srcParam;
    if (!src.startsWith("http://") && !src.startsWith("https://")) src = "https://" + src;
    urlObj.searchParams.delete("url");
    const operations = $f0811e54c17867e6$var$operationsParser(urlObj);
    return {
        src: src,
        operations: operations
    };
};
const $f0811e54c17867e6$export$80d376111cc09ad7 = (src, operations)=>{
    const url = new URL("https://wsrv.nl/");
    const srcUrl = typeof src === "string" ? src : src.toString();
    const cleanSrc = srcUrl.replace(/^https?:\/\//, "");
    url.searchParams.set("url", cleanSrc);
    const params = $f0811e54c17867e6$var$operationsGenerator(operations);
    const searchParams = new URLSearchParams(params);
    for (const [key, value] of searchParams)if (key !== "url") url.searchParams.set(key, value);
    return (0, $7fc80789f446ee4c$export$9a5ff27ac96579c6)(url);
};
const $f0811e54c17867e6$export$51186ad6e864892a = (0, $7fc80789f446ee4c$export$ed17cc3414a57fef)($f0811e54c17867e6$export$f9380c9a627682d3, $f0811e54c17867e6$export$80d376111cc09ad7);


const $a27c401c1eb60728$var$transformerMap = {
    appwrite: $60c2c3a42a1591bd$export$51186ad6e864892a,
    astro: $b575084008b0fba0$export$51186ad6e864892a,
    "builder.io": (0, $ef083e35e12fb11e$export$51186ad6e864892a),
    bunny: $15146dd326cf0e2c$export$51186ad6e864892a,
    cloudflare: $b40d718d8aa6c68a$export$51186ad6e864892a,
    cloudflare_images: $2e5a179ef0001d59$export$51186ad6e864892a,
    cloudimage: $c670bc17a8232fd7$export$51186ad6e864892a,
    cloudinary: $40535ce10939c9f7$export$51186ad6e864892a,
    contentful: $0eb0a3f2f31ee582$export$51186ad6e864892a,
    contentstack: $b2e5a4418abc5d00$export$51186ad6e864892a,
    directus: $ab3e54b82570deb1$export$51186ad6e864892a,
    hygraph: $b192cd11847635f9$export$51186ad6e864892a,
    imageengine: $c33d1d6e207c23fc$export$51186ad6e864892a,
    imagekit: $733dde3329e4fce8$export$51186ad6e864892a,
    imgix: $e334b29624873677$export$51186ad6e864892a,
    ipx: $bea2dd7c9fdc3169$export$51186ad6e864892a,
    keycdn: $9614c2ac2f9d2894$export$51186ad6e864892a,
    "kontent.ai": (0, $ca9a9f4f1852b9c1$export$51186ad6e864892a),
    netlify: $8d164ef40fd3ad1c$export$51186ad6e864892a,
    nextjs: $dd42ee47c04381cf$export$51186ad6e864892a,
    scene7: $d8d1ce1feb92dd01$export$51186ad6e864892a,
    shopify: $bbe9f58116cfab10$export$51186ad6e864892a,
    storyblok: $b2b7de334e9aa1c8$export$51186ad6e864892a,
    supabase: $ecc2ae357e45815a$export$51186ad6e864892a,
    truocloud: $a31e1c0a1463f77f$export$51186ad6e864892a,
    uploadcare: $b28c18204baa06d6$export$51186ad6e864892a,
    vercel: $7cdce42a27092b75$export$51186ad6e864892a,
    wordpress: $b989e946d7b3952c$export$51186ad6e864892a,
    wsrv: $f0811e54c17867e6$export$51186ad6e864892a
};
function $a27c401c1eb60728$export$a8bd7c998575ac50(cdn) {
    if (!cdn) return undefined;
    return $a27c401c1eb60728$var$transformerMap[cdn];
}
function $a27c401c1eb60728$export$f784c93c2c19988({ url: url, provider: provider, cdn: cdnOption, fallback: fallback, width: width, height: height, format: format, quality: quality }, providerOperations, providerOptions) {
    const cdn = provider || cdnOption || (0, $b3d17ad6c3624999$export$b74eb3c64b89e7b4)(url) || fallback;
    if (!cdn) return undefined;
    return $a27c401c1eb60728$export$a8bd7c998575ac50(cdn)?.(url, {
        ...{
            width: width,
            height: height,
            format: format,
            quality: quality
        },
        ...providerOperations?.[cdn]
    }, providerOptions?.[cdn] ?? {});
}

































const $346741b2db32fa2e$export$19131010e7fd8373 = {
    appwrite: $60c2c3a42a1591bd$export$f9380c9a627682d3,
    astro: $b575084008b0fba0$export$f9380c9a627682d3,
    "builder.io": (0, $ef083e35e12fb11e$export$f9380c9a627682d3),
    bunny: $15146dd326cf0e2c$export$f9380c9a627682d3,
    cloudflare: $b40d718d8aa6c68a$export$f9380c9a627682d3,
    cloudflare_images: (0, $2e5a179ef0001d59$export$f9380c9a627682d3),
    cloudimage: $c670bc17a8232fd7$export$f9380c9a627682d3,
    cloudinary: $40535ce10939c9f7$export$f9380c9a627682d3,
    contentful: $0eb0a3f2f31ee582$export$f9380c9a627682d3,
    contentstack: $b2e5a4418abc5d00$export$f9380c9a627682d3,
    directus: $ab3e54b82570deb1$export$f9380c9a627682d3,
    hygraph: $b192cd11847635f9$export$f9380c9a627682d3,
    imageengine: $c33d1d6e207c23fc$export$f9380c9a627682d3,
    imagekit: $733dde3329e4fce8$export$f9380c9a627682d3,
    imgix: $e334b29624873677$export$f9380c9a627682d3,
    ipx: $bea2dd7c9fdc3169$export$f9380c9a627682d3,
    keycdn: $9614c2ac2f9d2894$export$f9380c9a627682d3,
    "kontent.ai": (0, $ca9a9f4f1852b9c1$export$f9380c9a627682d3),
    netlify: $8d164ef40fd3ad1c$export$f9380c9a627682d3,
    nextjs: $dd42ee47c04381cf$export$f9380c9a627682d3,
    scene7: $d8d1ce1feb92dd01$export$f9380c9a627682d3,
    shopify: $bbe9f58116cfab10$export$f9380c9a627682d3,
    storyblok: $b2b7de334e9aa1c8$export$f9380c9a627682d3,
    supabase: $ecc2ae357e45815a$export$f9380c9a627682d3,
    truocloud: $a31e1c0a1463f77f$export$f9380c9a627682d3,
    uploadcare: $b28c18204baa06d6$export$f9380c9a627682d3,
    vercel: $7cdce42a27092b75$export$f9380c9a627682d3,
    wordpress: $b989e946d7b3952c$export$f9380c9a627682d3,
    wsrv: $f0811e54c17867e6$export$f9380c9a627682d3
};
const $346741b2db32fa2e$export$ef4abe7db6c5479f = (url)=>$346741b2db32fa2e$export$3ce4c973e1fba9e1((0, $b3d17ad6c3624999$export$b74eb3c64b89e7b4)(url));
const $346741b2db32fa2e$export$3ce4c973e1fba9e1 = (cdn)=>{
    if (!cdn) return undefined;
    return $346741b2db32fa2e$export$19131010e7fd8373[cdn];
};
const $346741b2db32fa2e$export$7a5253c0f62e0150 = (url, cdn, options)=>{
    const detectedCdn = cdn || (0, $b3d17ad6c3624999$export$b74eb3c64b89e7b4)(url);
    if (!detectedCdn) return undefined;
    const parser = $346741b2db32fa2e$export$3ce4c973e1fba9e1(detectedCdn);
    if (!parser) return {
        src: url.toString(),
        operations: {},
        options: {},
        cdn: detectedCdn
    };
    return {
        ...parser(url, options),
        cdn: detectedCdn
    };
};






var $4b19e90a86648102$var$t, $4b19e90a86648102$var$r, $4b19e90a86648102$var$u, $4b19e90a86648102$var$i, $4b19e90a86648102$var$o = 0, $4b19e90a86648102$var$f = [], $4b19e90a86648102$var$c = (0, $ff68197639d628de$export$41c562ebe57d11e2), $4b19e90a86648102$var$e = $4b19e90a86648102$var$c.__b, $4b19e90a86648102$var$a = $4b19e90a86648102$var$c.__r, $4b19e90a86648102$var$v = $4b19e90a86648102$var$c.diffed, $4b19e90a86648102$var$l = $4b19e90a86648102$var$c.__c, $4b19e90a86648102$var$m = $4b19e90a86648102$var$c.unmount, $4b19e90a86648102$var$s = $4b19e90a86648102$var$c.__;
function $4b19e90a86648102$var$d(n, t) {
    $4b19e90a86648102$var$c.__h && $4b19e90a86648102$var$c.__h($4b19e90a86648102$var$r, n, $4b19e90a86648102$var$o || t), $4b19e90a86648102$var$o = 0;
    var u = $4b19e90a86648102$var$r.__H || ($4b19e90a86648102$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $4b19e90a86648102$export$60241385465d0a34(n) {
    return $4b19e90a86648102$var$o = 1, $4b19e90a86648102$export$13e3392192263954($4b19e90a86648102$var$D, n);
}
function $4b19e90a86648102$export$13e3392192263954(n, u, i) {
    var o = $4b19e90a86648102$var$d($4b19e90a86648102$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $4b19e90a86648102$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $4b19e90a86648102$var$r, !$4b19e90a86648102$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $4b19e90a86648102$var$r.u = !0;
        var c = $4b19e90a86648102$var$r.shouldComponentUpdate, e = $4b19e90a86648102$var$r.componentWillUpdate;
        $4b19e90a86648102$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $4b19e90a86648102$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $4b19e90a86648102$export$6d9c69b0de29b591(n, u) {
    var i = $4b19e90a86648102$var$d($4b19e90a86648102$var$t++, 3);
    !$4b19e90a86648102$var$c.__s && $4b19e90a86648102$var$C(i.__H, u) && (i.__ = n, i.i = u, $4b19e90a86648102$var$r.__H.__h.push(i));
}
function $4b19e90a86648102$export$e5c5a5f917a5871c(n, u) {
    var i = $4b19e90a86648102$var$d($4b19e90a86648102$var$t++, 4);
    !$4b19e90a86648102$var$c.__s && $4b19e90a86648102$var$C(i.__H, u) && (i.__ = n, i.i = u, $4b19e90a86648102$var$r.__h.push(i));
}
function $4b19e90a86648102$export$b8f5890fc79d6aca(n) {
    return $4b19e90a86648102$var$o = 5, $4b19e90a86648102$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $4b19e90a86648102$export$d5a552a76deda3c2(n, t, r) {
    $4b19e90a86648102$var$o = 6, $4b19e90a86648102$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $4b19e90a86648102$export$1538c33de8887b59(n, r) {
    var u = $4b19e90a86648102$var$d($4b19e90a86648102$var$t++, 7);
    return $4b19e90a86648102$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $4b19e90a86648102$export$35808ee640e87ca7(n, t) {
    return $4b19e90a86648102$var$o = 8, $4b19e90a86648102$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $4b19e90a86648102$export$fae74005e78b1a27(n) {
    var u = $4b19e90a86648102$var$r.context[n.__c], i = $4b19e90a86648102$var$d($4b19e90a86648102$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($4b19e90a86648102$var$r)), u.props.value) : n.__;
}
function $4b19e90a86648102$export$dc8fbce3eb94dc1e(n, t) {
    $4b19e90a86648102$var$c.useDebugValue && $4b19e90a86648102$var$c.useDebugValue(t ? t(n) : n);
}
function $4b19e90a86648102$export$c052f6604b7d51fe(n) {
    var u = $4b19e90a86648102$var$d($4b19e90a86648102$var$t++, 10), i = $4b19e90a86648102$export$60241385465d0a34();
    return u.__ = n, $4b19e90a86648102$var$r.componentDidCatch || ($4b19e90a86648102$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $4b19e90a86648102$export$f680877a34711e37() {
    var n = $4b19e90a86648102$var$d($4b19e90a86648102$var$t++, 11);
    if (!n.__) {
        for(var u = $4b19e90a86648102$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $4b19e90a86648102$var$j() {
    for(var n; n = $4b19e90a86648102$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($4b19e90a86648102$var$z), n.__H.__h.forEach($4b19e90a86648102$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $4b19e90a86648102$var$c.__e(t, n.__v);
    }
}
$4b19e90a86648102$var$c.__b = function(n) {
    $4b19e90a86648102$var$r = null, $4b19e90a86648102$var$e && $4b19e90a86648102$var$e(n);
}, $4b19e90a86648102$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $4b19e90a86648102$var$s && $4b19e90a86648102$var$s(n, t);
}, $4b19e90a86648102$var$c.__r = function(n) {
    $4b19e90a86648102$var$a && $4b19e90a86648102$var$a(n), $4b19e90a86648102$var$t = 0;
    var i = ($4b19e90a86648102$var$r = n.__c).__H;
    i && ($4b19e90a86648102$var$u === $4b19e90a86648102$var$r ? (i.__h = [], $4b19e90a86648102$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
    })) : (i.__h.forEach($4b19e90a86648102$var$z), i.__h.forEach($4b19e90a86648102$var$B), i.__h = [], $4b19e90a86648102$var$t = 0)), $4b19e90a86648102$var$u = $4b19e90a86648102$var$r;
}, $4b19e90a86648102$var$c.diffed = function(n) {
    $4b19e90a86648102$var$v && $4b19e90a86648102$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $4b19e90a86648102$var$f.push(t) && $4b19e90a86648102$var$i === $4b19e90a86648102$var$c.requestAnimationFrame || (($4b19e90a86648102$var$i = $4b19e90a86648102$var$c.requestAnimationFrame) || $4b19e90a86648102$var$w)($4b19e90a86648102$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.i = void 0;
    })), $4b19e90a86648102$var$u = $4b19e90a86648102$var$r = null;
}, $4b19e90a86648102$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($4b19e90a86648102$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $4b19e90a86648102$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $4b19e90a86648102$var$c.__e(r, n.__v);
        }
    }), $4b19e90a86648102$var$l && $4b19e90a86648102$var$l(n, t);
}, $4b19e90a86648102$var$c.unmount = function(n) {
    $4b19e90a86648102$var$m && $4b19e90a86648102$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $4b19e90a86648102$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $4b19e90a86648102$var$c.__e(t, r.__v));
};
var $4b19e90a86648102$var$k = "function" == typeof requestAnimationFrame;
function $4b19e90a86648102$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $4b19e90a86648102$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $4b19e90a86648102$var$k && (t = requestAnimationFrame(r));
}
function $4b19e90a86648102$var$z(n) {
    var t = $4b19e90a86648102$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $4b19e90a86648102$var$r = t;
}
function $4b19e90a86648102$var$B(n) {
    var t = $4b19e90a86648102$var$r;
    n.__c = n.__(), $4b19e90a86648102$var$r = t;
}
function $4b19e90a86648102$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $4b19e90a86648102$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


var $e773c77aaecced8e$var$i = Symbol.for("preact-signals");
function $e773c77aaecced8e$var$t() {
    if (!($e773c77aaecced8e$var$s > 1)) {
        var i, t = !1;
        while(void 0 !== $e773c77aaecced8e$var$h){
            var r = $e773c77aaecced8e$var$h;
            $e773c77aaecced8e$var$h = void 0;
            $e773c77aaecced8e$var$f++;
            while(void 0 !== r){
                var o = r.o;
                r.o = void 0;
                r.f &= -3;
                if (!(8 & r.f) && $e773c77aaecced8e$var$c(r)) try {
                    r.c();
                } catch (r) {
                    if (!t) {
                        i = r;
                        t = !0;
                    }
                }
                r = o;
            }
        }
        $e773c77aaecced8e$var$f = 0;
        $e773c77aaecced8e$var$s--;
        if (t) throw i;
    } else $e773c77aaecced8e$var$s--;
}
function $e773c77aaecced8e$export$712ea50be43a7858(i) {
    if ($e773c77aaecced8e$var$s > 0) return i();
    $e773c77aaecced8e$var$s++;
    try {
        return i();
    } finally{
        $e773c77aaecced8e$var$t();
    }
}
var $e773c77aaecced8e$var$o = void 0;
function $e773c77aaecced8e$export$8c437e4d572e2f99(i) {
    var t = $e773c77aaecced8e$var$o;
    $e773c77aaecced8e$var$o = void 0;
    try {
        return i();
    } finally{
        $e773c77aaecced8e$var$o = t;
    }
}
var $e773c77aaecced8e$var$h = void 0, $e773c77aaecced8e$var$s = 0, $e773c77aaecced8e$var$f = 0, $e773c77aaecced8e$var$v = 0;
function $e773c77aaecced8e$var$e(i) {
    if (void 0 !== $e773c77aaecced8e$var$o) {
        var t = i.n;
        if (void 0 === t || t.t !== $e773c77aaecced8e$var$o) {
            t = {
                i: 0,
                S: i,
                p: $e773c77aaecced8e$var$o.s,
                n: void 0,
                t: $e773c77aaecced8e$var$o,
                e: void 0,
                x: void 0,
                r: t
            };
            if (void 0 !== $e773c77aaecced8e$var$o.s) $e773c77aaecced8e$var$o.s.n = t;
            $e773c77aaecced8e$var$o.s = t;
            i.n = t;
            if (32 & $e773c77aaecced8e$var$o.f) i.S(t);
            return t;
        } else if (-1 === t.i) {
            t.i = 0;
            if (void 0 !== t.n) {
                t.n.p = t.p;
                if (void 0 !== t.p) t.p.n = t.n;
                t.p = $e773c77aaecced8e$var$o.s;
                t.n = void 0;
                $e773c77aaecced8e$var$o.s.n = t;
                $e773c77aaecced8e$var$o.s = t;
            }
            return t;
        }
    }
}
function $e773c77aaecced8e$export$8210dfe1863c478(i) {
    this.v = i;
    this.i = 0;
    this.n = void 0;
    this.t = void 0;
}
$e773c77aaecced8e$export$8210dfe1863c478.prototype.brand = $e773c77aaecced8e$var$i;
$e773c77aaecced8e$export$8210dfe1863c478.prototype.h = function() {
    return !0;
};
$e773c77aaecced8e$export$8210dfe1863c478.prototype.S = function(i) {
    if (this.t !== i && void 0 === i.e) {
        i.x = this.t;
        if (void 0 !== this.t) this.t.e = i;
        this.t = i;
    }
};
$e773c77aaecced8e$export$8210dfe1863c478.prototype.U = function(i) {
    if (void 0 !== this.t) {
        var t = i.e, r = i.x;
        if (void 0 !== t) {
            t.x = r;
            i.e = void 0;
        }
        if (void 0 !== r) {
            r.e = t;
            i.x = void 0;
        }
        if (i === this.t) this.t = r;
    }
};
$e773c77aaecced8e$export$8210dfe1863c478.prototype.subscribe = function(i) {
    var t = this;
    return $e773c77aaecced8e$export$dc573d8a6576cdb3(function() {
        var r = t.value, n = $e773c77aaecced8e$var$o;
        $e773c77aaecced8e$var$o = void 0;
        try {
            i(r);
        } finally{
            $e773c77aaecced8e$var$o = n;
        }
    });
};
$e773c77aaecced8e$export$8210dfe1863c478.prototype.valueOf = function() {
    return this.value;
};
$e773c77aaecced8e$export$8210dfe1863c478.prototype.toString = function() {
    return this.value + "";
};
$e773c77aaecced8e$export$8210dfe1863c478.prototype.toJSON = function() {
    return this.value;
};
$e773c77aaecced8e$export$8210dfe1863c478.prototype.peek = function() {
    var i = $e773c77aaecced8e$var$o;
    $e773c77aaecced8e$var$o = void 0;
    try {
        return this.value;
    } finally{
        $e773c77aaecced8e$var$o = i;
    }
};
Object.defineProperty($e773c77aaecced8e$export$8210dfe1863c478.prototype, "value", {
    get: function() {
        var i = $e773c77aaecced8e$var$e(this);
        if (void 0 !== i) i.i = this.i;
        return this.v;
    },
    set: function(i) {
        if (i !== this.v) {
            if ($e773c77aaecced8e$var$f > 100) throw new Error("Cycle detected");
            this.v = i;
            this.i++;
            $e773c77aaecced8e$var$v++;
            $e773c77aaecced8e$var$s++;
            try {
                for(var r = this.t; void 0 !== r; r = r.x)r.t.N();
            } finally{
                $e773c77aaecced8e$var$t();
            }
        }
    }
});
function $e773c77aaecced8e$export$e2ef10f86a8d60e8(i) {
    return new $e773c77aaecced8e$export$8210dfe1863c478(i);
}
function $e773c77aaecced8e$var$c(i) {
    for(var t = i.s; void 0 !== t; t = t.n)if (t.S.i !== t.i || !t.S.h() || t.S.i !== t.i) return !0;
    return !1;
}
function $e773c77aaecced8e$var$a(i) {
    for(var t = i.s; void 0 !== t; t = t.n){
        var r = t.S.n;
        if (void 0 !== r) t.r = r;
        t.S.n = t;
        t.i = -1;
        if (void 0 === t.n) {
            i.s = t;
            break;
        }
    }
}
function $e773c77aaecced8e$var$l(i) {
    var t = i.s, r = void 0;
    while(void 0 !== t){
        var o = t.p;
        if (-1 === t.i) {
            t.S.U(t);
            if (void 0 !== o) o.n = t.n;
            if (void 0 !== t.n) t.n.p = o;
        } else r = t;
        t.S.n = t.r;
        if (void 0 !== t.r) t.r = void 0;
        t = o;
    }
    i.s = r;
}
function $e773c77aaecced8e$var$y(i) {
    $e773c77aaecced8e$export$8210dfe1863c478.call(this, void 0);
    this.x = i;
    this.s = void 0;
    this.g = $e773c77aaecced8e$var$v - 1;
    this.f = 4;
}
($e773c77aaecced8e$var$y.prototype = new $e773c77aaecced8e$export$8210dfe1863c478).h = function() {
    this.f &= -3;
    if (1 & this.f) return !1;
    if (32 == (36 & this.f)) return !0;
    this.f &= -5;
    if (this.g === $e773c77aaecced8e$var$v) return !0;
    this.g = $e773c77aaecced8e$var$v;
    this.f |= 1;
    if (this.i > 0 && !$e773c77aaecced8e$var$c(this)) {
        this.f &= -2;
        return !0;
    }
    var i = $e773c77aaecced8e$var$o;
    try {
        $e773c77aaecced8e$var$a(this);
        $e773c77aaecced8e$var$o = this;
        var t = this.x();
        if (16 & this.f || this.v !== t || 0 === this.i) {
            this.v = t;
            this.f &= -17;
            this.i++;
        }
    } catch (i) {
        this.v = i;
        this.f |= 16;
        this.i++;
    }
    $e773c77aaecced8e$var$o = i;
    $e773c77aaecced8e$var$l(this);
    this.f &= -2;
    return !0;
};
$e773c77aaecced8e$var$y.prototype.S = function(i) {
    if (void 0 === this.t) {
        this.f |= 36;
        for(var t = this.s; void 0 !== t; t = t.n)t.S.S(t);
    }
    $e773c77aaecced8e$export$8210dfe1863c478.prototype.S.call(this, i);
};
$e773c77aaecced8e$var$y.prototype.U = function(i) {
    if (void 0 !== this.t) {
        $e773c77aaecced8e$export$8210dfe1863c478.prototype.U.call(this, i);
        if (void 0 === this.t) {
            this.f &= -33;
            for(var t = this.s; void 0 !== t; t = t.n)t.S.U(t);
        }
    }
};
$e773c77aaecced8e$var$y.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 6;
        for(var i = this.t; void 0 !== i; i = i.x)i.t.N();
    }
};
Object.defineProperty($e773c77aaecced8e$var$y.prototype, "value", {
    get: function() {
        if (1 & this.f) throw new Error("Cycle detected");
        var i = $e773c77aaecced8e$var$e(this);
        this.h();
        if (void 0 !== i) i.i = this.i;
        if (16 & this.f) throw this.v;
        return this.v;
    }
});
function $e773c77aaecced8e$export$2983e091f1a1e8e2(i) {
    return new $e773c77aaecced8e$var$y(i);
}
function $e773c77aaecced8e$var$_(i) {
    var r = i.u;
    i.u = void 0;
    if ("function" == typeof r) {
        $e773c77aaecced8e$var$s++;
        var n = $e773c77aaecced8e$var$o;
        $e773c77aaecced8e$var$o = void 0;
        try {
            r();
        } catch (t) {
            i.f &= -2;
            i.f |= 8;
            $e773c77aaecced8e$var$g(i);
            throw t;
        } finally{
            $e773c77aaecced8e$var$o = n;
            $e773c77aaecced8e$var$t();
        }
    }
}
function $e773c77aaecced8e$var$g(i) {
    for(var t = i.s; void 0 !== t; t = t.n)t.S.U(t);
    i.x = void 0;
    i.s = void 0;
    $e773c77aaecced8e$var$_(i);
}
function $e773c77aaecced8e$var$p(i) {
    if ($e773c77aaecced8e$var$o !== this) throw new Error("Out-of-order effect");
    $e773c77aaecced8e$var$l(this);
    $e773c77aaecced8e$var$o = i;
    this.f &= -2;
    if (8 & this.f) $e773c77aaecced8e$var$g(this);
    $e773c77aaecced8e$var$t();
}
function $e773c77aaecced8e$var$b(i) {
    this.x = i;
    this.u = void 0;
    this.s = void 0;
    this.o = void 0;
    this.f = 32;
}
$e773c77aaecced8e$var$b.prototype.c = function() {
    var i = this.S();
    try {
        if (8 & this.f) return;
        if (void 0 === this.x) return;
        var t = this.x();
        if ("function" == typeof t) this.u = t;
    } finally{
        i();
    }
};
$e773c77aaecced8e$var$b.prototype.S = function() {
    if (1 & this.f) throw new Error("Cycle detected");
    this.f |= 1;
    this.f &= -9;
    $e773c77aaecced8e$var$_(this);
    $e773c77aaecced8e$var$a(this);
    $e773c77aaecced8e$var$s++;
    var i = $e773c77aaecced8e$var$o;
    $e773c77aaecced8e$var$o = this;
    return $e773c77aaecced8e$var$p.bind(this, i);
};
$e773c77aaecced8e$var$b.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 2;
        this.o = $e773c77aaecced8e$var$h;
        $e773c77aaecced8e$var$h = this;
    }
};
$e773c77aaecced8e$var$b.prototype.d = function() {
    this.f |= 8;
    if (!(1 & this.f)) $e773c77aaecced8e$var$g(this);
};
function $e773c77aaecced8e$export$dc573d8a6576cdb3(i) {
    var t = new $e773c77aaecced8e$var$b(i);
    try {
        t.c();
    } catch (i) {
        t.d();
        throw i;
    }
    return t.d.bind(t);
}


var $897460c6287b7be0$var$v, $897460c6287b7be0$var$s;
function $897460c6287b7be0$var$l(n, i) {
    (0, $ff68197639d628de$export$41c562ebe57d11e2)[n] = i.bind(null, (0, $ff68197639d628de$export$41c562ebe57d11e2)[n] || function() {});
}
function $897460c6287b7be0$var$d(n) {
    if ($897460c6287b7be0$var$s) $897460c6287b7be0$var$s();
    $897460c6287b7be0$var$s = n && n.S();
}
function $897460c6287b7be0$var$p(n) {
    var r = this, f = n.data, o = $897460c6287b7be0$export$65d8bf213f6a4478(f);
    o.value = f;
    var e = (0, $4b19e90a86648102$export$1538c33de8887b59)(function() {
        var n = r.__v;
        while(n = n.__)if (n.__c) {
            n.__c.__$f |= 4;
            break;
        }
        r.__$u.c = function() {
            var n, t = r.__$u.S(), f = e.value;
            t();
            if ((0, $ff68197639d628de$export$a8257692ac88316c)(f) || 3 !== (null == (n = r.base) ? void 0 : n.nodeType)) {
                r.__$f |= 1;
                r.setState({});
            } else r.base.data = f;
        };
        return (0, $e773c77aaecced8e$export$2983e091f1a1e8e2)(function() {
            var n = o.value.value;
            return 0 === n ? 0 : !0 === n ? "" : n || "";
        });
    }, []);
    return e.value;
}
$897460c6287b7be0$var$p.displayName = "_st";
Object.defineProperties((0, $e773c77aaecced8e$export$8210dfe1863c478).prototype, {
    constructor: {
        configurable: !0,
        value: void 0
    },
    type: {
        configurable: !0,
        value: $897460c6287b7be0$var$p
    },
    props: {
        configurable: !0,
        get: function() {
            return {
                data: this
            };
        }
    },
    __b: {
        configurable: !0,
        value: 1
    }
});
$897460c6287b7be0$var$l("__b", function(n, r) {
    if ("string" == typeof r.type) {
        var i, t = r.props;
        for(var f in t)if ("children" !== f) {
            var o = t[f];
            if (o instanceof (0, $e773c77aaecced8e$export$8210dfe1863c478)) {
                if (!i) r.__np = i = {};
                i[f] = o;
                t[f] = o.peek();
            }
        }
    }
    n(r);
});
$897460c6287b7be0$var$l("__r", function(n, r) {
    $897460c6287b7be0$var$d();
    var i, t = r.__c;
    if (t) {
        t.__$f &= -2;
        if (void 0 === (i = t.__$u)) t.__$u = i = function(n) {
            var r;
            (0, $e773c77aaecced8e$export$dc573d8a6576cdb3)(function() {
                r = this;
            });
            r.c = function() {
                t.__$f |= 1;
                t.setState({});
            };
            return r;
        }();
    }
    $897460c6287b7be0$var$v = t;
    $897460c6287b7be0$var$d(i);
    n(r);
});
$897460c6287b7be0$var$l("__e", function(n, r, i, t) {
    $897460c6287b7be0$var$d();
    $897460c6287b7be0$var$v = void 0;
    n(r, i, t);
});
$897460c6287b7be0$var$l("diffed", function(n, r) {
    $897460c6287b7be0$var$d();
    $897460c6287b7be0$var$v = void 0;
    var i;
    if ("string" == typeof r.type && (i = r.__e)) {
        var t = r.__np, f = r.props;
        if (t) {
            var o = i.U;
            if (o) for(var e in o){
                var u = o[e];
                if (void 0 !== u && !(e in t)) {
                    u.d();
                    o[e] = void 0;
                }
            }
            else i.U = o = {};
            for(var a in t){
                var c = o[a], s = t[a];
                if (void 0 === c) {
                    c = $897460c6287b7be0$var$_(i, a, s, f);
                    o[a] = c;
                } else c.o(s, f);
            }
        }
    }
    n(r);
});
function $897460c6287b7be0$var$_(n, r, i, t) {
    var f = r in n && void 0 === n.ownerSVGElement, o = (0, $e773c77aaecced8e$export$e2ef10f86a8d60e8)(i);
    return {
        o: function(n, r) {
            o.value = n;
            t = r;
        },
        d: (0, $e773c77aaecced8e$export$dc573d8a6576cdb3)(function() {
            var i = o.value.value;
            if (t[r] !== i) {
                t[r] = i;
                if (f) n[r] = i;
                else if (i) n.setAttribute(r, i);
                else n.removeAttribute(r);
            }
        })
    };
}
$897460c6287b7be0$var$l("unmount", function(n, r) {
    if ("string" == typeof r.type) {
        var i = r.__e;
        if (i) {
            var t = i.U;
            if (t) {
                i.U = void 0;
                for(var f in t){
                    var o = t[f];
                    if (o) o.d();
                }
            }
        }
    } else {
        var e = r.__c;
        if (e) {
            var u = e.__$u;
            if (u) {
                e.__$u = void 0;
                u.d();
            }
        }
    }
    n(r);
});
$897460c6287b7be0$var$l("__h", function(n, r, i, t) {
    if (t < 3 || 9 === t) r.__$f |= 2;
    n(r, i, t);
});
(0, $ff68197639d628de$export$16fa2f45be04daa8).prototype.shouldComponentUpdate = function(n, r) {
    var i = this.__$u;
    if (!(i && void 0 !== i.s || 4 & this.__$f)) return !0;
    if (3 & this.__$f) return !0;
    for(var t in r)return !0;
    for(var f in n)if ("__source" !== f && n[f] !== this.props[f]) return !0;
    for(var o in this.props)if (!(o in n)) return !0;
    return !1;
};
function $897460c6287b7be0$export$65d8bf213f6a4478(n) {
    return (0, $4b19e90a86648102$export$1538c33de8887b59)(function() {
        return (0, $e773c77aaecced8e$export$e2ef10f86a8d60e8)(n);
    }, []);
}
function $897460c6287b7be0$export$e3d20747ab930783(n) {
    var r = (0, $4b19e90a86648102$export$b8f5890fc79d6aca)(n);
    r.current = n;
    $897460c6287b7be0$var$v.__$f |= 4;
    return (0, $4b19e90a86648102$export$1538c33de8887b59)(function() {
        return (0, $e773c77aaecced8e$export$2983e091f1a1e8e2)(function() {
            return r.current();
        });
    }, []);
}
function $897460c6287b7be0$export$ed99038c4a6f842a(n) {
    var r = (0, $4b19e90a86648102$export$b8f5890fc79d6aca)(n);
    r.current = n;
    (0, $4b19e90a86648102$export$6d9c69b0de29b591)(function() {
        return (0, $e773c77aaecced8e$export$dc573d8a6576cdb3)(function() {
            return r.current();
        });
    }, []);
}



var $6e2fc30c303696dc$exports = {};
$6e2fc30c303696dc$exports = JSON.parse("{\"shopify\":[\"Shopify\",\"https://cdn.shopify.com/static/sample-images/bath_grande_crop_center.jpeg\"],\"contentful\":[\"Contentful\",\"https://images.ctfassets.net/yadj1kx9rmg0/wtrHxeu3zEoEce2MokCSi/cf6f68efdcf625fdc060607df0f3baef/quwowooybuqbl6ntboz3.jpg?fm=jpg\"],\"builder.io\":[\"Builder.io\",\"https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F462d29d57dda42cb9e26441501db535f\"],\"cloudinary\":[\"Cloudinary\",\"https://res.cloudinary.com/demo/image/upload/c_lfill,w_800,h_550,f_auto/dog.webp\"],\"imgix\":[\"Imgix\",\"https://images.unsplash.com/photo-1674255909399-9bcb2cab6489?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=996&q=80\"],\"wordpress\":[\"WordPress\",\"https://cultivatedemo.files.wordpress.com/2022/06/marisa-morton-c9xtptclntg-unsplash-1.jpg\"],\"bunny\":[\"Bunny.net\",\"https://bunnyoptimizerdemo.b-cdn.net/bunny7.jpg?width=300\"],\"storyblok\":[\"Storyblok\",\"https://a.storyblok.com/f/39898/3310x2192/e4ec08624e/demo-image.jpeg/m/-800x600/filters:round_corner(30,255,255,255)\"],\"cloudflare\":[\"Cloudflare\",\"https://assets.brevity.io/cdn-cgi/image/background=red,width=128,height=128,f=auto/uploads/generic/avatar-sample.jpeg\"],\"kontent.ai\":[\"Kontent.ai\",\"https://assets-us-01.kc-usercontent.com/b744f382-bfc7-434d-93e7-a65d51249bc7/cc0afdc7-23d7-4fde-be2c-f58ad54d2934/daylight.jpg\"],\"nextjs\":[\"Next.js\",\"https://image-component.nextjs.gallery/_next/image?url=%252F_next%252Fstatic%252Fmedia%252Fmountains.a2eb1d50.jpg\"],\"scene7\":[\"Adobe Dynamic Media (Scene7)\",\"https://s7d1.scene7.com/is/image/sample/s9?wid=500&hei=700&fmt=webp\"],\"keycdn\":[\"KeyCDN\",\"https://ip.keycdn.com/example.jpg\"],\"imageengine\":[\"ImageEngine\",\"https://blazing-fast-pics.cdn.imgeng.in/images/pic_3.jpg?imgeng=/w_400\"],\"contentstack\":[\"Contentstack\",\"https://images.contentstack.io/v3/assets/blteae40eb499811073/bltc5064f36b5855343/59e0c41ac0eddd140d5a8e3e/owl.jpg\"],\"cloudflare_images\":[\"Cloudflare Images\",\"https://100francisco.com/cdn-cgi/imagedelivery/1aS6NlIe-Sc1o3NhVvy8Qw/2ba36ba9-69f6-41b6-8ff0-2779b41df200\"],\"ipx\":[\"IPX\",\"https://deploy-preview-125--unpic-playground.netlify.app/_ipx/w_450/https://unpic.pics/tree.png\"],\"netlify\":[\"Netlify\",\"https://unpic-playground.netlify.app/.netlify/images?url=/cappadocia.jpg\"],\"imagekit\":[\"Imagekit\",\"https://ik.imagekit.io/demo/medium_cafe_B1iTdD0C.jpg\"],\"cloudimage\":[\"Cloudimage\",\"https://doc.cloudimg.io/sample.li/flat1.jpg?w=450&q=90\"],\"uploadcare\":[\"Uploadcare\",\"https://ucarecdn.com/661bd414-064c-477a-b50f-8ffd8f66aa49/\"],\"truocloud\":[\"TruoCloud\",\"https://img.truo.cloud/i/demo/wikipedia/commons/3/3f/Fronalpstock_big.jpg\"],\"supabase\":[\"Supabase\",\"https://enlyjtqaeutqbhqgkadn.supabase.co/storage/v1/object/public/sample-public-bucket/alexander-shatov-PHH_0uw9-Qw-unsplash.jpg\"],\"vercel\":[\"Vercel\",\"https://build-output-api-image-optimization.vercel.sh/_vercel/image?url=%2Fimages%2Frio.jpeg\"],\"hygraph\":[\"Hygraph\",\"https://us-west-2.graphassets.com/cm2apl1zp07l506n66dmd9xo8/cm2tr64fx7gvu07n85chjmuno\"],\"appwrite\":[\"Appwrite\",\"https://cloud.appwrite.io/v1/storage/buckets/unpic/files/679d127100131f67b6d8/view?project=unpic-test\"],\"wsrv\":[\"wsrv.nl\",\"https://wsrv.nl/?url=images.unsplash.com/photo-1560807707-8cc77767d783\"]}");


const $1b8e0994176c9ade$var$inputUrl = (0, $e773c77aaecced8e$export$e2ef10f86a8d60e8)((0, (/*@__PURE__*/$parcel$interopDefault($6e2fc30c303696dc$exports))).shopify[1]);
const $1b8e0994176c9ade$var$cdn = (0, $e773c77aaecced8e$export$e2ef10f86a8d60e8)("");
const $1b8e0994176c9ade$var$width = (0, $e773c77aaecced8e$export$e2ef10f86a8d60e8)(800);
const $1b8e0994176c9ade$var$height = (0, $e773c77aaecced8e$export$e2ef10f86a8d60e8)(600);
const $1b8e0994176c9ade$var$url = (0, $e773c77aaecced8e$export$2983e091f1a1e8e2)(()=>{
    try {
        return (0, $a27c401c1eb60728$export$f784c93c2c19988)({
            url: $1b8e0994176c9ade$var$inputUrl.value,
            width: Number($1b8e0994176c9ade$var$width.value),
            height: Number($1b8e0994176c9ade$var$height.value),
            provider: $1b8e0994176c9ade$var$cdn.value || undefined
        });
    } catch (e) {
        console.error(e);
        return null;
    }
});
const $1b8e0994176c9ade$var$parsedUrl = (0, $e773c77aaecced8e$export$2983e091f1a1e8e2)(()=>{
    try {
        return JSON.stringify((0, $346741b2db32fa2e$export$7a5253c0f62e0150)($1b8e0994176c9ade$var$inputUrl.value), null, 2);
    } catch (e) {
        return "Invalid URL";
    }
});
const $1b8e0994176c9ade$var$code = (0, $e773c77aaecced8e$export$2983e091f1a1e8e2)(()=>/* javascript */ `const url = transformUrl({
  url: ${JSON.stringify($1b8e0994176c9ade$var$inputUrl.value)},
  width: ${$1b8e0994176c9ade$var$width},
  height: ${$1b8e0994176c9ade$var$height}
});`);
function $1b8e0994176c9ade$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", null, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("h1", null, "\uD83D\uDDBC Unpic"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("p", {
        class: "instructions"
    }, "Enter an image URL below, or choose from one of the examples"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", {
        class: "tools"
    }, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", {
        class: "example"
    }, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("label", {
        for: "example"
    }, "Load example"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("select", {
        onChange: (e)=>{
            $1b8e0994176c9ade$var$inputUrl.value = e.target.value;
        },
        id: "example"
    }, Object.values((0, (/*@__PURE__*/$parcel$interopDefault($6e2fc30c303696dc$exports)))).map(([name, url])=>/*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("option", {
            value: url
        }, name)))), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", {
        class: "cdn"
    }, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("label", {
        for: "cdn"
    }, "Force CDN"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("select", {
        onChange: (e)=>$1b8e0994176c9ade$var$cdn.value = e.target.value,
        id: "cdn"
    }, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("option", {
        value: ""
    }, "Auto"), Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($6e2fc30c303696dc$exports)))).map(([cdnKey, [name]])=>/*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("option", {
            value: cdnKey
        }, name)))), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", {
        class: "url"
    }, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("label", {
        for: "url"
    }, "Source URL"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("input", {
        id: "url",
        type: "text",
        value: $1b8e0994176c9ade$var$inputUrl,
        onInput: (e)=>$1b8e0994176c9ade$var$inputUrl.value = e.target.value
    })), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", null, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("label", {
        for: "width"
    }, "Width"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("input", {
        type: "text",
        inputMode: "numeric",
        id: "width",
        value: $1b8e0994176c9ade$var$width,
        onInput: (e)=>$1b8e0994176c9ade$var$width.value = e.target.value
    })), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", null, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("label", {
        for: "height"
    }, "Height"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("input", {
        type: "text",
        inputMode: "numeric",
        id: "height",
        value: $1b8e0994176c9ade$var$height,
        onInput: (e)=>$1b8e0994176c9ade$var$height.value = e.target.value
    })), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", {
        class: "result"
    }, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("label", null, "Result"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("input", {
        readonly: true,
        value: $1b8e0994176c9ade$var$url
    })), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("details", null, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("summary", null, "Show details"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", null, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", {
        class: "code"
    }, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", null, "Result"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("pre", null, $1b8e0994176c9ade$var$parsedUrl)), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", {
        class: "code"
    }, /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", null, "Code"), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("pre", null, $1b8e0994176c9ade$var$code))))), /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("div", {
        class: "imagePanel"
    }, $1b8e0994176c9ade$var$url.value ? /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("img", {
        src: $1b8e0994176c9ade$var$url,
        width: $1b8e0994176c9ade$var$width,
        height: $1b8e0994176c9ade$var$height
    }) : /*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)("p", null, "Invalid URL")));
}


(0, $ff68197639d628de$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $ff68197639d628de$export$c8a8987d4410bf2d)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), null), document.getElementById("root"));


//# sourceMappingURL=index.a002e4d9.js.map
